export const officeOrderFinanceAnalyticsConstants = {
  GET_OFFICE_ORDER_FINANCE_ANALYTICS_REQUEST: "GET_OFFICE_ORDER_FINANCE_ANALYTICS_REQUEST",
  GET_OFFICE_ORDER_FINANCE_ANALYTICS_SUCCESS: "GET_OFFICE_ORDER_FINANCE_ANALYTICS_SUCCESS",
  GET_OFFICE_ORDER_FINANCE_ANALYTICS_FAILURE: "GET_OFFICE_ORDER_FINANCE_ANALYTICS_FAILURE",
  CLEAR_OFFICE_ORDER_FINANCE_ANALYTICS: "CLEAR_OFFICE_ORDER_FINANCE_ANALYTICS",
};

export const officeOrderModalConstants = {
  OFFICE_ORDER_MODAL_OPEN: "OFFICE_ORDER_MODAL_OPEN",
  OFFICE_ORDER_MODAL_CLOSE: "OFFICE_ORDER_MODAL_CLOSE",
  OFFICE_ORDER_MODAL_SET_TAB: "OFFICE_ORDER_MODAL_SET_TAB",
  OFFICE_ORDER_MODAL_SET_PANEL: "OFFICE_ORDER_MODAL_SET_PANEL",
  OFFICE_ORDER_MODAL_PATCH: "OFFICE_ORDER_MODAL_PATCH",
};

export const officeEntityModalConstants = {
  OFFICE_ENTITY_MODAL_OPEN: "OFFICE_ENTITY_MODAL_OPEN",
  OFFICE_ENTITY_MODAL_CLOSE: "OFFICE_ENTITY_MODAL_CLOSE",
};

export const officePaymentAccountConstants = {
  OFFICE_PAYMENT_METHODS_REQUEST: "OFFICE_PAYMENT_METHODS_REQUEST",
  OFFICE_PAYMENT_METHODS_SUCCESS: "OFFICE_PAYMENT_METHODS_SUCCESS",
  OFFICE_PAYMENT_METHODS_FAILURE: "OFFICE_PAYMENT_METHODS_FAILURE",

  OFFICE_PAYMENT_ACCOUNTS_REQUEST: "OFFICE_PAYMENT_ACCOUNTS_REQUEST",
  OFFICE_PAYMENT_ACCOUNTS_SUCCESS: "OFFICE_PAYMENT_ACCOUNTS_SUCCESS",
  OFFICE_PAYMENT_ACCOUNTS_FAILURE: "OFFICE_PAYMENT_ACCOUNTS_FAILURE",

  OFFICE_PAYMENT_ACCOUNT_CREATE_REQUEST: "OFFICE_PAYMENT_ACCOUNT_CREATE_REQUEST",
  OFFICE_PAYMENT_ACCOUNT_CREATE_SUCCESS: "OFFICE_PAYMENT_ACCOUNT_CREATE_SUCCESS",
  OFFICE_PAYMENT_ACCOUNT_CREATE_FAILURE: "OFFICE_PAYMENT_ACCOUNT_CREATE_FAILURE",

  OFFICE_PAYMENT_ACCOUNT_DELETE_REQUEST: "OFFICE_PAYMENT_ACCOUNT_DELETE_REQUEST",
  OFFICE_PAYMENT_ACCOUNT_DELETE_SUCCESS: "OFFICE_PAYMENT_ACCOUNT_DELETE_SUCCESS",
  OFFICE_PAYMENT_ACCOUNT_DELETE_FAILURE: "OFFICE_PAYMENT_ACCOUNT_DELETE_FAILURE",

  OFFICE_PAYMENT_METHOD_SAVE_REQUEST: "OFFICE_PAYMENT_METHOD_SAVE_REQUEST",
  OFFICE_PAYMENT_METHOD_SAVE_SUCCESS: "OFFICE_PAYMENT_METHOD_SAVE_SUCCESS",
  OFFICE_PAYMENT_METHOD_SAVE_FAILURE: "OFFICE_PAYMENT_METHOD_SAVE_FAILURE",

  OFFICE_PAYMENT_CLEAR_ALERT: "OFFICE_PAYMENT_CLEAR_ALERT",
  OFFICE_PAYMENT_CLEAR_STATE: "OFFICE_PAYMENT_CLEAR_STATE",
};

export const officeOrderConstants = {
  OFFICE_ORDER_SET_MODE: "OFFICE_ORDER_SET_MODE",
  OFFICE_ORDER_CLOSE_ALERT: "OFFICE_ORDER_CLOSE_ALERT",

  OFFICE_ORDER_COLORS_REQUEST: "OFFICE_ORDER_COLORS_REQUEST",
  OFFICE_ORDER_COLORS_SUCCESS: "OFFICE_ORDER_COLORS_SUCCESS",
  OFFICE_ORDER_COLORS_FAILURE: "OFFICE_ORDER_COLORS_FAILURE",

  OFFICE_ORDER_LIST_REQUEST: "OFFICE_ORDER_LIST_REQUEST",
  OFFICE_ORDER_LIST_SUCCESS: "OFFICE_ORDER_LIST_SUCCESS",
  OFFICE_ORDER_LIST_FAILURE: "OFFICE_ORDER_LIST_FAILURE",

  OFFICE_ORDER_SEARCH_REQUEST: "OFFICE_ORDER_SEARCH_REQUEST",
  OFFICE_ORDER_SEARCH_SUCCESS: "OFFICE_ORDER_SEARCH_SUCCESS",
  OFFICE_ORDER_SEARCH_FAILURE: "OFFICE_ORDER_SEARCH_FAILURE",

  OFFICE_ORDER_DETAILS_REQUEST: "OFFICE_ORDER_DETAILS_REQUEST",
  OFFICE_ORDER_DETAILS_SUCCESS: "OFFICE_ORDER_DETAILS_SUCCESS",
  OFFICE_ORDER_DETAILS_FAILURE: "OFFICE_ORDER_DETAILS_FAILURE",

  OFFICE_ORDER_CREATE_REQUEST: "OFFICE_ORDER_CREATE_REQUEST",
  OFFICE_ORDER_CREATE_SUCCESS: "OFFICE_ORDER_CREATE_SUCCESS",
  OFFICE_ORDER_CREATE_FAILURE: "OFFICE_ORDER_CREATE_FAILURE",

  OFFICE_ORDER_MUTATION_REQUEST: "OFFICE_ORDER_MUTATION_REQUEST",
  OFFICE_ORDER_MUTATION_SUCCESS: "OFFICE_ORDER_MUTATION_SUCCESS",
  OFFICE_ORDER_MUTATION_FAILURE: "OFFICE_ORDER_MUTATION_FAILURE",
};

export const calc3dUiConstants = {
  SET_CALC3D_ACTIVE_TAB: 'SET_CALC3D_ACTIVE_TAB',
  SET_CALC3D_HEADER_VISIBLE: 'SET_CALC3D_HEADER_VISIBLE',
  SET_CALC3D_PANEL_OPEN: 'SET_CALC3D_PANEL_OPEN',
  TOGGLE_CALC3D_PANEL_OPEN: 'TOGGLE_CALC3D_PANEL_OPEN',
  TOGGLE_CALC3D_HEADER_VISIBLE: 'TOGGLE_CALC3D_HEADER_VISIBLE',

  SET_CALC3D_CART_DIALOG_OPEN: 'SET_CALC3D_CART_DIALOG_OPEN',

  SET_CALC3D_RENDER_MODAL: 'SET_CALC3D_RENDER_MODAL',
  SET_CALC3D_RENDER_MODAL_OPEN: 'SET_CALC3D_RENDER_MODAL_OPEN',
  SET_CALC3D_RENDER_MODAL_CURRENT_ID: 'SET_CALC3D_RENDER_MODAL_CURRENT_ID',

  PATCH_CALC3D_CATEGORY_STATE: 'PATCH_CALC3D_CATEGORY_STATE',
  REPLACE_CALC3D_CATEGORY_STATE: 'REPLACE_CALC3D_CATEGORY_STATE',

  SET_CALC3D_SCENE_DOCK: 'SET_CALC3D_SCENE_DOCK',
  SET_CALC3D_SCENE_DOCK_FIELD: 'SET_CALC3D_SCENE_DOCK_FIELD',

  SET_CALC3D_RIGHT_PANEL_OPEN_KEY: 'SET_CALC3D_RIGHT_PANEL_OPEN_KEY',

  SET_CALC3D_ACTION_HINT: 'SET_CALC3D_ACTION_HINT',
  CLEAR_CALC3D_ACTION_HINT: 'CLEAR_CALC3D_ACTION_HINT',

  PATCH_CALC3D_UI_STATE: 'PATCH_CALC3D_UI_STATE',
  APPLY_CALC3D_UI_STATE: 'APPLY_CALC3D_UI_STATE',
  RESET_CALC3D_UI_STATE: 'RESET_CALC3D_UI_STATE',
}

export const officeSalesSessionConstants = {
  LIST_OFFICE_SALES_SESSIONS_REQUEST: 'LIST_OFFICE_SALES_SESSIONS_REQUEST',
  LIST_OFFICE_SALES_SESSIONS_SUCCESS: 'LIST_OFFICE_SALES_SESSIONS_SUCCESS',
  LIST_OFFICE_SALES_SESSIONS_FAILURE: 'LIST_OFFICE_SALES_SESSIONS_FAILURE',

  CREATE_OFFICE_SALES_SESSION_REQUEST: 'CREATE_OFFICE_SALES_SESSION_REQUEST',
  CREATE_OFFICE_SALES_SESSION_SUCCESS: 'CREATE_OFFICE_SALES_SESSION_SUCCESS',
  CREATE_OFFICE_SALES_SESSION_FAILURE: 'CREATE_OFFICE_SALES_SESSION_FAILURE',

  GET_OFFICE_SALES_SESSION_REQUEST: 'GET_OFFICE_SALES_SESSION_REQUEST',
  GET_OFFICE_SALES_SESSION_SUCCESS: 'GET_OFFICE_SALES_SESSION_SUCCESS',
  GET_OFFICE_SALES_SESSION_FAILURE: 'GET_OFFICE_SALES_SESSION_FAILURE',

  UPDATE_OFFICE_SALES_SESSION_REQUEST: 'UPDATE_OFFICE_SALES_SESSION_REQUEST',
  UPDATE_OFFICE_SALES_SESSION_SUCCESS: 'UPDATE_OFFICE_SALES_SESSION_SUCCESS',
  UPDATE_OFFICE_SALES_SESSION_FAILURE: 'UPDATE_OFFICE_SALES_SESSION_FAILURE',

  CLOSE_OFFICE_SALES_SESSION_REQUEST: 'CLOSE_OFFICE_SALES_SESSION_REQUEST',
  CLOSE_OFFICE_SALES_SESSION_SUCCESS: 'CLOSE_OFFICE_SALES_SESSION_SUCCESS',
  CLOSE_OFFICE_SALES_SESSION_FAILURE: 'CLOSE_OFFICE_SALES_SESSION_FAILURE',

  REOPEN_OFFICE_SALES_SESSION_REQUEST: 'REOPEN_OFFICE_SALES_SESSION_REQUEST',
  REOPEN_OFFICE_SALES_SESSION_SUCCESS: 'REOPEN_OFFICE_SALES_SESSION_SUCCESS',
  REOPEN_OFFICE_SALES_SESSION_FAILURE: 'REOPEN_OFFICE_SALES_SESSION_FAILURE',

  CREATE_OFFICE_SALES_SESSION_INVITE_REQUEST: 'CREATE_OFFICE_SALES_SESSION_INVITE_REQUEST',
  CREATE_OFFICE_SALES_SESSION_INVITE_SUCCESS: 'CREATE_OFFICE_SALES_SESSION_INVITE_SUCCESS',
  CREATE_OFFICE_SALES_SESSION_INVITE_FAILURE: 'CREATE_OFFICE_SALES_SESSION_INVITE_FAILURE',

  SET_ACTIVE_OFFICE_SALES_SESSION: 'SET_ACTIVE_OFFICE_SALES_SESSION',
  PATCH_ACTIVE_OFFICE_SALES_SESSION: 'PATCH_ACTIVE_OFFICE_SALES_SESSION',
  CLEAR_ACTIVE_OFFICE_SALES_SESSION: 'CLEAR_ACTIVE_OFFICE_SALES_SESSION',
}

export const operationTypeConstants = {
  LIST_REQUEST: 'OFFICE_OPERATION_TYPE_LIST_REQUEST',
  LIST_SUCCESS: 'OFFICE_OPERATION_TYPE_LIST_SUCCESS',
  LIST_FAILURE: 'OFFICE_OPERATION_TYPE_LIST_FAILURE',
}

export const productOperationTemplateConstants = {
  LIST_REQUEST: 'PRODUCT_OPERATION_TEMPLATE_LIST_REQUEST',
  LIST_SUCCESS: 'PRODUCT_OPERATION_TEMPLATE_LIST_SUCCESS',
  LIST_FAILURE: 'PRODUCT_OPERATION_TEMPLATE_LIST_FAILURE',

  RESOLVE_REQUEST: 'PRODUCT_OPERATION_TEMPLATE_RESOLVE_REQUEST',
  RESOLVE_SUCCESS: 'PRODUCT_OPERATION_TEMPLATE_RESOLVE_SUCCESS',
  RESOLVE_FAILURE: 'PRODUCT_OPERATION_TEMPLATE_RESOLVE_FAILURE',
}

export const productionTariffConstants = {
  LIST_REQUEST: 'PRODUCTION_TARIFF_LIST_REQUEST',
  LIST_SUCCESS: 'PRODUCTION_TARIFF_LIST_SUCCESS',
  LIST_FAILURE: 'PRODUCTION_TARIFF_LIST_FAILURE',

  RESOLVE_REQUEST: 'PRODUCTION_TARIFF_RESOLVE_REQUEST',
  RESOLVE_SUCCESS: 'PRODUCTION_TARIFF_RESOLVE_SUCCESS',
  RESOLVE_FAILURE: 'PRODUCTION_TARIFF_RESOLVE_FAILURE',

  CALCULATE_REQUEST: 'PRODUCTION_TARIFF_CALCULATE_REQUEST',
  CALCULATE_SUCCESS: 'PRODUCTION_TARIFF_CALCULATE_SUCCESS',
  CALCULATE_FAILURE: 'PRODUCTION_TARIFF_CALCULATE_FAILURE',
}

export const officeProductOfferConstants = {
  LIST_REQUEST: 'OFFICE_PRODUCT_OFFER_LIST_REQUEST',
  LIST_SUCCESS: 'OFFICE_PRODUCT_OFFER_LIST_SUCCESS',
  LIST_FAILURE: 'OFFICE_PRODUCT_OFFER_LIST_FAILURE',

  ENABLED_REQUEST: 'OFFICE_PRODUCT_OFFER_ENABLED_REQUEST',
  ENABLED_SUCCESS: 'OFFICE_PRODUCT_OFFER_ENABLED_SUCCESS',
  ENABLED_FAILURE: 'OFFICE_PRODUCT_OFFER_ENABLED_FAILURE',

  ADD_REQUEST: 'OFFICE_PRODUCT_OFFER_ADD_REQUEST',
  ADD_SUCCESS: 'OFFICE_PRODUCT_OFFER_ADD_SUCCESS',
  ADD_FAILURE: 'OFFICE_PRODUCT_OFFER_ADD_FAILURE',

  UPDATE_REQUEST: 'OFFICE_PRODUCT_OFFER_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'OFFICE_PRODUCT_OFFER_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'OFFICE_PRODUCT_OFFER_UPDATE_FAILURE',

  REMOVE_REQUEST: 'OFFICE_PRODUCT_OFFER_REMOVE_REQUEST',
  REMOVE_SUCCESS: 'OFFICE_PRODUCT_OFFER_REMOVE_SUCCESS',
  REMOVE_FAILURE: 'OFFICE_PRODUCT_OFFER_REMOVE_FAILURE',
}

export const officeProductOperationPriceConstants = {
  LIST_PRODUCT_REQUEST: 'OFFICE_PRODUCT_OPERATION_PRICE_LIST_PRODUCT_REQUEST',
  LIST_PRODUCT_SUCCESS: 'OFFICE_PRODUCT_OPERATION_PRICE_LIST_PRODUCT_SUCCESS',
  LIST_PRODUCT_FAILURE: 'OFFICE_PRODUCT_OPERATION_PRICE_LIST_PRODUCT_FAILURE',

  RESOLVE_PRODUCT_REQUEST: 'OFFICE_PRODUCT_OPERATION_PRICE_RESOLVE_PRODUCT_REQUEST',
  RESOLVE_PRODUCT_SUCCESS: 'OFFICE_PRODUCT_OPERATION_PRICE_RESOLVE_PRODUCT_SUCCESS',
  RESOLVE_PRODUCT_FAILURE: 'OFFICE_PRODUCT_OPERATION_PRICE_RESOLVE_PRODUCT_FAILURE',

  UPSERT_REQUEST: 'OFFICE_PRODUCT_OPERATION_PRICE_UPSERT_REQUEST',
  UPSERT_SUCCESS: 'OFFICE_PRODUCT_OPERATION_PRICE_UPSERT_SUCCESS',
  UPSERT_FAILURE: 'OFFICE_PRODUCT_OPERATION_PRICE_UPSERT_FAILURE',

  REMOVE_REQUEST: 'OFFICE_PRODUCT_OPERATION_PRICE_REMOVE_REQUEST',
  REMOVE_SUCCESS: 'OFFICE_PRODUCT_OPERATION_PRICE_REMOVE_SUCCESS',
  REMOVE_FAILURE: 'OFFICE_PRODUCT_OPERATION_PRICE_REMOVE_FAILURE',

  CALCULATE_REQUEST: 'OFFICE_PRODUCT_OPERATION_PRICE_CALCULATE_REQUEST',
  CALCULATE_SUCCESS: 'OFFICE_PRODUCT_OPERATION_PRICE_CALCULATE_SUCCESS',
  CALCULATE_FAILURE: 'OFFICE_PRODUCT_OPERATION_PRICE_CALCULATE_FAILURE',
}

export const accountProfileConstants = {
  SEND_EMAIL_VERIFICATION_REQUEST: "SEND_EMAIL_VERIFICATION_REQUEST",
  SEND_EMAIL_VERIFICATION_SUCCESS: "SEND_EMAIL_VERIFICATION_SUCCESS",
  SEND_EMAIL_VERIFICATION_FAILURE: "SEND_EMAIL_VERIFICATION_FAILURE",

  CONFIRM_EMAIL_VERIFICATION_REQUEST: "CONFIRM_EMAIL_VERIFICATION_REQUEST",
  CONFIRM_EMAIL_VERIFICATION_SUCCESS: "CONFIRM_EMAIL_VERIFICATION_SUCCESS",
  CONFIRM_EMAIL_VERIFICATION_FAILURE: "CONFIRM_EMAIL_VERIFICATION_FAILURE",

  UPDATE_NEWSLETTER_SETTINGS_REQUEST: "UPDATE_NEWSLETTER_SETTINGS_REQUEST",
  UPDATE_NEWSLETTER_SETTINGS_SUCCESS: "UPDATE_NEWSLETTER_SETTINGS_SUCCESS",
  UPDATE_NEWSLETTER_SETTINGS_FAILURE: "UPDATE_NEWSLETTER_SETTINGS_FAILURE",

  REFRESH_ACCOUNT_PROFILE_REQUEST: "REFRESH_ACCOUNT_PROFILE_REQUEST",
  REFRESH_ACCOUNT_PROFILE_SUCCESS: "REFRESH_ACCOUNT_PROFILE_SUCCESS",
  REFRESH_ACCOUNT_PROFILE_FAILURE: "REFRESH_ACCOUNT_PROFILE_FAILURE",

  CLEAR_ACCOUNT_PROFILE_STATUS: "CLEAR_ACCOUNT_PROFILE_STATUS",
};

export const mailingConstants = {
  SEND_MAILING_REQUEST: "SEND_MAILING_REQUEST",
  SEND_MAILING_SUCCESS: "SEND_MAILING_SUCCESS",
  SEND_MAILING_FAILURE: "SEND_MAILING_FAILURE",

  GET_MAILING_REQUEST: "GET_MAILING_REQUEST",
  GET_MAILING_SUCCESS: "GET_MAILING_SUCCESS",
  GET_MAILING_FAILURE: "GET_MAILING_FAILURE",

  GET_BY_ID_MAILING_REQUEST: "GET_BY_ID_MAILING_REQUEST",
  GET_BY_ID_MAILING_SUCCESS: "GET_BY_ID_MAILING_SUCCESS",
  GET_BY_ID_MAILING_FAILURE: "GET_BY_ID_MAILING_FAILURE",

  ADD_MAILING_REQUEST: "ADD_MAILING_REQUEST",
  ADD_MAILING_SUCCESS: "ADD_MAILING_SUCCESS",
  ADD_MAILING_FAILURE: "ADD_MAILING_FAILURE",

  CLEAR_MAILING_STATUS: "CLEAR_MAILING_STATUS",
  SET_CLOSE_ALERT: "SET_CLOSE_ALERT",
};

export const officeInviteConstants = {
  CREATE_OFFICE_INVITE_REQUEST: "CREATE_OFFICE_INVITE_REQUEST",
  CREATE_OFFICE_INVITE_SUCCESS: "CREATE_OFFICE_INVITE_SUCCESS",
  CREATE_OFFICE_INVITE_FAILURE: "CREATE_OFFICE_INVITE_FAILURE",

  GET_OFFICE_INVITES_REQUEST: "GET_OFFICE_INVITES_REQUEST",
  GET_OFFICE_INVITES_SUCCESS: "GET_OFFICE_INVITES_SUCCESS",
  GET_OFFICE_INVITES_FAILURE: "GET_OFFICE_INVITES_FAILURE",

  CANCEL_OFFICE_INVITE_REQUEST: "CANCEL_OFFICE_INVITE_REQUEST",
  CANCEL_OFFICE_INVITE_SUCCESS: "CANCEL_OFFICE_INVITE_SUCCESS",
  CANCEL_OFFICE_INVITE_FAILURE: "CANCEL_OFFICE_INVITE_FAILURE",

  GET_OFFICE_INVITE_BY_TOKEN_REQUEST: "GET_OFFICE_INVITE_BY_TOKEN_REQUEST",
  GET_OFFICE_INVITE_BY_TOKEN_SUCCESS: "GET_OFFICE_INVITE_BY_TOKEN_SUCCESS",
  GET_OFFICE_INVITE_BY_TOKEN_FAILURE: "GET_OFFICE_INVITE_BY_TOKEN_FAILURE",

  ACCEPT_OFFICE_INVITE_REQUEST: "ACCEPT_OFFICE_INVITE_REQUEST",
  ACCEPT_OFFICE_INVITE_SUCCESS: "ACCEPT_OFFICE_INVITE_SUCCESS",
  ACCEPT_OFFICE_INVITE_FAILURE: "ACCEPT_OFFICE_INVITE_FAILURE",

  DECLINE_OFFICE_INVITE_REQUEST: "DECLINE_OFFICE_INVITE_REQUEST",
  DECLINE_OFFICE_INVITE_SUCCESS: "DECLINE_OFFICE_INVITE_SUCCESS",
  DECLINE_OFFICE_INVITE_FAILURE: "DECLINE_OFFICE_INVITE_FAILURE",

  CLEAR_OFFICE_INVITE_ERROR: "CLEAR_OFFICE_INVITE_ERROR",
  CLEAR_PUBLIC_OFFICE_INVITE: "CLEAR_PUBLIC_OFFICE_INVITE",
};

export const officeMemberConstants = {
  GET_OFFICE_MEMBERS_REQUEST: "GET_OFFICE_MEMBERS_REQUEST",
  GET_OFFICE_MEMBERS_SUCCESS: "GET_OFFICE_MEMBERS_SUCCESS",
  GET_OFFICE_MEMBERS_FAILURE: "GET_OFFICE_MEMBERS_FAILURE",

  ADD_OFFICE_MEMBER_REQUEST: "ADD_OFFICE_MEMBER_REQUEST",
  ADD_OFFICE_MEMBER_SUCCESS: "ADD_OFFICE_MEMBER_SUCCESS",
  ADD_OFFICE_MEMBER_FAILURE: "ADD_OFFICE_MEMBER_FAILURE",

  UPDATE_OFFICE_MEMBER_REQUEST: "UPDATE_OFFICE_MEMBER_REQUEST",
  UPDATE_OFFICE_MEMBER_SUCCESS: "UPDATE_OFFICE_MEMBER_SUCCESS",
  UPDATE_OFFICE_MEMBER_FAILURE: "UPDATE_OFFICE_MEMBER_FAILURE",

  REMOVE_OFFICE_MEMBER_REQUEST: "REMOVE_OFFICE_MEMBER_REQUEST",
  REMOVE_OFFICE_MEMBER_SUCCESS: "REMOVE_OFFICE_MEMBER_SUCCESS",
  REMOVE_OFFICE_MEMBER_FAILURE: "REMOVE_OFFICE_MEMBER_FAILURE",

  GET_MY_OFFICE_MEMBERSHIPS_REQUEST: "GET_MY_OFFICE_MEMBERSHIPS_REQUEST",
  GET_MY_OFFICE_MEMBERSHIPS_SUCCESS: "GET_MY_OFFICE_MEMBERSHIPS_SUCCESS",
  GET_MY_OFFICE_MEMBERSHIPS_FAILURE: "GET_MY_OFFICE_MEMBERSHIPS_FAILURE",

  REBUILD_OFFICE_MEMBERS_REQUEST: "REBUILD_OFFICE_MEMBERS_REQUEST",
  REBUILD_OFFICE_MEMBERS_SUCCESS: "REBUILD_OFFICE_MEMBERS_SUCCESS",
  REBUILD_OFFICE_MEMBERS_FAILURE: "REBUILD_OFFICE_MEMBERS_FAILURE",

  CLEAR_OFFICE_MEMBERS_ERROR: "CLEAR_OFFICE_MEMBERS_ERROR",
};

export const billingConstants = {
  INIT_TOPUP_REQUEST: 'INIT_TOPUP_REQUEST',
  INIT_TOPUP_SUCCESS: 'INIT_TOPUP_SUCCESS',
  INIT_TOPUP_FAILURE: 'INIT_TOPUP_FAILURE',

  APPLY_PROMO_REQUEST: 'APPLY_PROMO_REQUEST',
  APPLY_PROMO_SUCCESS: 'APPLY_PROMO_SUCCESS',
  APPLY_PROMO_FAILURE: 'APPLY_PROMO_FAILURE',

  PAY_SCENE_REQUEST: 'PAY_SCENE_REQUEST',
  PAY_SCENE_SUCCESS: 'PAY_SCENE_SUCCESS',
  PAY_SCENE_FAILURE: 'PAY_SCENE_FAILURE',

  PAY_SCENE_ACCESS_REQUEST: 'PAY_SCENE_ACCESS_REQUEST',
  PAY_SCENE_ACCESS_SUCCESS: 'PAY_SCENE_ACCESS_SUCCESS',
  PAY_SCENE_ACCESS_FAILURE: 'PAY_SCENE_ACCESS_FAILURE',

  GET_TRANSACTIONS_REQUEST: 'GET_TRANSACTIONS_REQUEST',
  GET_TRANSACTIONS_SUCCESS: 'GET_TRANSACTIONS_SUCCESS',
  GET_TRANSACTIONS_FAILURE: 'GET_TRANSACTIONS_FAILURE',

  BUY_SUBSCRIPTION_REQUEST: 'BUY_SUBSCRIPTION_REQUEST',
  BUY_SUBSCRIPTION_SUCCESS: 'BUY_SUBSCRIPTION_SUCCESS',
  BUY_SUBSCRIPTION_FAILURE: 'BUY_SUBSCRIPTION_FAILURE',

  CANCEL_SUBSCRIPTION_REQUEST: 'CANCEL_SUBSCRIPTION_REQUEST',
  CANCEL_SUBSCRIPTION_SUCCESS: 'CANCEL_SUBSCRIPTION_SUCCESS',
  CANCEL_SUBSCRIPTION_FAILURE: 'CANCEL_SUBSCRIPTION_FAILURE',

  ENABLE_SUBSCRIPTION_AUTORENEW_REQUEST: 'ENABLE_SUBSCRIPTION_AUTORENEW_REQUEST',
  ENABLE_SUBSCRIPTION_AUTORENEW_SUCCESS: 'ENABLE_SUBSCRIPTION_AUTORENEW_SUCCESS',
  ENABLE_SUBSCRIPTION_AUTORENEW_FAILURE: 'ENABLE_SUBSCRIPTION_AUTORENEW_FAILURE',

  TRANSFER_TO_OFFICE_REQUEST: 'TRANSFER_TO_OFFICE_REQUEST',
  TRANSFER_TO_OFFICE_SUCCESS: 'TRANSFER_TO_OFFICE_SUCCESS',
  TRANSFER_TO_OFFICE_FAILURE: 'TRANSFER_TO_OFFICE_FAILURE',

  CLOSE_BILLING_ALERT: 'CLOSE_BILLING_ALERT'
};

export const accessGateConstants = {
  ACCESS_GATE_OPEN: 'ACCESS_GATE_OPEN',
  ACCESS_GATE_CLOSE: 'ACCESS_GATE_CLOSE',
  ACCESS_GATE_CLEAR: 'ACCESS_GATE_CLEAR',
  ACCESS_GATE_PATCH: 'ACCESS_GATE_PATCH',
};

export const officeAnalyticsConstants = {
  GET_OFFICE_ANALYTICS_REQUEST: "GET_OFFICE_ANALYTICS_REQUEST",
  GET_OFFICE_ANALYTICS_SUCCESS: "GET_OFFICE_ANALYTICS_SUCCESS",
  GET_OFFICE_ANALYTICS_FAILURE: "GET_OFFICE_ANALYTICS_FAILURE",
  CLEAR_OFFICE_ANALYTICS: "CLEAR_OFFICE_ANALYTICS",
};

export const measureConstants = {
  SET_MEASURE_MODE: 'SET_MEASURE_MODE',
  SET_MEASURE_COLOR: 'SET_MEASURE_COLOR',
  SET_MEASURE_SNAP_FLOOR: 'SET_MEASURE_SNAP_FLOOR',

  ADD_MEASURE: 'ADD_MEASURE',
  REMOVE_MEASURE: 'REMOVE_MEASURE',
  TOGGLE_MEASURE: 'TOGGLE_MEASURE',
  RENAME_MEASURE: 'RENAME_MEASURE',
  SET_MEASURE_ITEM_COLOR: 'SET_MEASURE_ITEM_COLOR',

  CLEAR_MEASURES: 'CLEAR_MEASURES',
}

export const officePriceConstants = {
  MAP_REQUEST: 'OFFICE_PRICE/MAP_REQUEST',
  MAP_SUCCESS: 'OFFICE_PRICE/MAP_SUCCESS',
  MAP_FAILURE: 'OFFICE_PRICE/MAP_FAILURE',

  SET_REQUEST: 'OFFICE_PRICE/SET_REQUEST',
  SET_SUCCESS: 'OFFICE_PRICE/SET_SUCCESS',
  SET_FAILURE: 'OFFICE_PRICE/SET_FAILURE',

  REMOVE_REQUEST: 'OFFICE_PRICE/REMOVE_REQUEST',
  REMOVE_SUCCESS: 'OFFICE_PRICE/REMOVE_SUCCESS',
  REMOVE_FAILURE: 'OFFICE_PRICE/REMOVE_FAILURE',
};

export const manualOrderConstants = {
  SEARCH_REQUEST: 'MANUAL_ORDER_SEARCH_REQUEST',
  SEARCH_SUCCESS: 'MANUAL_ORDER_SEARCH_SUCCESS',
  SEARCH_FAILURE: 'MANUAL_ORDER_SEARCH_FAILURE',

  CREATE_REQUEST: 'MANUAL_ORDER_CREATE_REQUEST',
  CREATE_SUCCESS: 'MANUAL_ORDER_CREATE_SUCCESS',
  CREATE_FAILURE: 'MANUAL_ORDER_CREATE_FAILURE',
};


// src/actions/constants.js
export const officeCategoryConstants = {
  SET_CURRENT_OFFICE: "SET_CURRENT_OFFICE",
  LIST_AVAILABLE_REQUEST: 'OFFICE_CAT/LIST_AVAILABLE_REQUEST',
  LIST_AVAILABLE_SUCCESS: 'OFFICE_CAT/LIST_AVAILABLE_SUCCESS',
  LIST_AVAILABLE_FAILURE: 'OFFICE_CAT/LIST_AVAILABLE_FAILURE',

  LIST_OWNED_REQUEST: 'OFFICE_CAT/LIST_OWNED_REQUEST',
  LIST_OWNED_SUCCESS: 'OFFICE_CAT/LIST_OWNED_SUCCESS',
  LIST_OWNED_FAILURE: 'OFFICE_CAT/LIST_OWNED_FAILURE',

  LIST_MINE_REQUEST: 'OFFICE_CAT/LIST_MINE_REQUEST',
  LIST_MINE_SUCCESS: 'OFFICE_CAT/LIST_MINE_SUCCESS',
  LIST_MINE_FAILURE: 'OFFICE_CAT/LIST_MINE_FAILURE',

  CREATE_REQUEST: 'OFFICE_CAT/CREATE_REQUEST',
  CREATE_SUCCESS: 'OFFICE_CAT/CREATE_SUCCESS',
  CREATE_FAILURE: 'OFFICE_CAT/CREATE_FAILURE',

  UPDATE_REQUEST: 'OFFICE_CAT/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'OFFICE_CAT/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'OFFICE_CAT/UPDATE_FAILURE',

  DELETE_REQUEST: 'OFFICE_CAT/DELETE_REQUEST',
  DELETE_SUCCESS: 'OFFICE_CAT/DELETE_SUCCESS',
  DELETE_FAILURE: 'OFFICE_CAT/DELETE_FAILURE',

  SHARE_REQUEST: 'OFFICE_CAT/SHARE_REQUEST',
  SHARE_SUCCESS: 'OFFICE_CAT/SHARE_SUCCESS',
  SHARE_FAILURE: 'OFFICE_CAT/SHARE_FAILURE',
};


// actions/constants.js
export const productOfficeConstants = {
  PRODUCT_OFFICE_BULK_ADD_REQUEST: 'PRODUCT_OFFICE_BULK_ADD_REQUEST',
  PRODUCT_OFFICE_BULK_ADD_SUCCESS: 'PRODUCT_OFFICE_BULK_ADD_SUCCESS',
  PRODUCT_OFFICE_BULK_ADD_FAILURE: 'PRODUCT_OFFICE_BULK_ADD_FAILURE',

  LIST_MINE_REQUEST: 'PO/LIST_MINE_REQUEST',
  LIST_MINE_SUCCESS: 'PO/LIST_MINE_SUCCESS',
  LIST_MINE_FAILURE: 'PO/LIST_MINE_FAILURE',

  LIST_OFFICE_REQUEST: 'PO/LIST_OFFICE_REQUEST',
  LIST_OFFICE_SUCCESS: 'PO/LIST_OFFICE_SUCCESS',
  LIST_OFFICE_FAILURE: 'PO/LIST_OFFICE_FAILURE',

  LIST_AVAILABLE_REQUEST: 'PO/LIST_AVAILABLE_REQUEST',
  LIST_AVAILABLE_SUCCESS: 'PO/LIST_AVAILABLE_SUCCESS',
  LIST_AVAILABLE_FAILURE: 'PO/LIST_AVAILABLE_FAILURE',

  CREATE_REQUEST: 'PO/CREATE_REQUEST',
  CREATE_SUCCESS: 'PO/CREATE_SUCCESS',
  CREATE_FAILURE: 'PO/CREATE_FAILURE',

  UPDATE_REQUEST: 'PO/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'PO/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'PO/UPDATE_FAILURE',

  ARCHIVE_REQUEST: 'PO/ARCHIVE_REQUEST',
  ARCHIVE_SUCCESS: 'PO/ARCHIVE_SUCCESS',
  ARCHIVE_FAILURE: 'PO/ARCHIVE_FAILURE',

  TOGGLE_VISIBLE_REQUEST: 'PO/TOGGLE_VISIBLE_REQUEST',
  TOGGLE_VISIBLE_SUCCESS: 'PO/TOGGLE_VISIBLE_SUCCESS',
  TOGGLE_VISIBLE_FAILURE: 'PO/TOGGLE_VISIBLE_FAILURE',

  SHARE_REQUEST: 'PO/SHARE_REQUEST',
  SHARE_SUCCESS: 'PO/SHARE_SUCCESS',
  SHARE_FAILURE: 'PO/SHARE_FAILURE',
};



// inventory.constants
export const inventoryConstants = {
  GET_BOM_PRODUCT_PICTURES_REQUEST: 'GET_BOM_PRODUCT_PICTURES_REQUEST',
  GET_BOM_PRODUCT_PICTURES_SUCCESS: 'GET_BOM_PRODUCT_PICTURES_SUCCESS',
  GET_BOM_PRODUCT_PICTURES_FAILURE: 'GET_BOM_PRODUCT_PICTURES_FAILURE',

  GET_WAREHOUSES_REQUEST: 'GET_WAREHOUSES_REQUEST',
  GET_WAREHOUSES_SUCCESS: 'GET_WAREHOUSES_SUCCESS',
  GET_WAREHOUSES_FAILURE: 'GET_WAREHOUSES_FAILURE',

  CREATE_WAREHOUSE_REQUEST: 'CREATE_WAREHOUSE_REQUEST',
  CREATE_WAREHOUSE_SUCCESS: 'CREATE_WAREHOUSE_SUCCESS',
  CREATE_WAREHOUSE_FAILURE: 'CREATE_WAREHOUSE_FAILURE',

  UPDATE_WAREHOUSE_REQUEST: 'UPDATE_WAREHOUSE_REQUEST',
  UPDATE_WAREHOUSE_SUCCESS: 'UPDATE_WAREHOUSE_SUCCESS',
  UPDATE_WAREHOUSE_FAILURE: 'UPDATE_WAREHOUSE_FAILURE',

  TOGGLE_WAREHOUSE_REQUEST: 'TOGGLE_WAREHOUSE_REQUEST',
  TOGGLE_WAREHOUSE_SUCCESS: 'TOGGLE_WAREHOUSE_SUCCESS',
  TOGGLE_WAREHOUSE_FAILURE: 'TOGGLE_WAREHOUSE_FAILURE',

  GET_STOCK_SUMMARY_REQUEST: 'GET_STOCK_SUMMARY_REQUEST',
  GET_STOCK_SUMMARY_SUCCESS: 'GET_STOCK_SUMMARY_SUCCESS',
  GET_STOCK_SUMMARY_FAILURE: 'GET_STOCK_SUMMARY_FAILURE',

  LIST_BATCHES_REQUEST: 'LIST_BATCHES_REQUEST',
  LIST_BATCHES_SUCCESS: 'LIST_BATCHES_SUCCESS',
  LIST_BATCHES_FAILURE: 'LIST_BATCHES_FAILURE',

  RECEIVE_STOCK_REQUEST: 'RECEIVE_STOCK_REQUEST',
  RECEIVE_STOCK_SUCCESS: 'RECEIVE_STOCK_SUCCESS',
  RECEIVE_STOCK_FAILURE: 'RECEIVE_STOCK_FAILURE',

  ADJUST_STOCK_REQUEST: 'ADJUST_STOCK_REQUEST',
  ADJUST_STOCK_SUCCESS: 'ADJUST_STOCK_SUCCESS',
  ADJUST_STOCK_FAILURE: 'ADJUST_STOCK_FAILURE',

  TRANSFER_STOCK_REQUEST: 'TRANSFER_STOCK_REQUEST',
  TRANSFER_STOCK_SUCCESS: 'TRANSFER_STOCK_SUCCESS',
  TRANSFER_STOCK_FAILURE: 'TRANSFER_STOCK_FAILURE',

  CLEANUP_STOCK_REQUEST: 'CLEANUP_STOCK_REQUEST',
  CLEANUP_STOCK_SUCCESS: 'CLEANUP_STOCK_SUCCESS',
  CLEANUP_STOCK_FAILURE: 'CLEANUP_STOCK_FAILURE',

  UPSERT_BOM_REQUEST: 'UPSERT_BOM_REQUEST',
  UPSERT_BOM_SUCCESS: 'UPSERT_BOM_SUCCESS',
  UPSERT_BOM_FAILURE: 'UPSERT_BOM_FAILURE',

  GET_BOM_REQUEST: 'GET_BOM_REQUEST',
  GET_BOM_SUCCESS: 'GET_BOM_SUCCESS',
  GET_BOM_FAILURE: 'GET_BOM_FAILURE',

  DELETE_BOM_REQUEST: 'DELETE_BOM_REQUEST',
  DELETE_BOM_SUCCESS: 'DELETE_BOM_SUCCESS',
  DELETE_BOM_FAILURE: 'DELETE_BOM_FAILURE',

  RESERVE_REQUEST: 'RESERVE_REQUEST',
  RESERVE_SUCCESS: 'RESERVE_SUCCESS',
  RESERVE_FAILURE: 'RESERVE_FAILURE',

  CONSUME_RESERVATION_REQUEST: 'CONSUME_RESERVATION_REQUEST',
  CONSUME_RESERVATION_SUCCESS: 'CONSUME_RESERVATION_SUCCESS',
  CONSUME_RESERVATION_FAILURE: 'CONSUME_RESERVATION_FAILURE',

  CANCEL_RESERVATION_REQUEST: 'CANCEL_RESERVATION_REQUEST',
  CANCEL_RESERVATION_SUCCESS: 'CANCEL_RESERVATION_SUCCESS',
  CANCEL_RESERVATION_FAILURE: 'CANCEL_RESERVATION_FAILURE',

  GET_RESERVATIONS_BY_ORDER_REQUEST: 'GET_RESERVATIONS_BY_ORDER_REQUEST',
  GET_RESERVATIONS_BY_ORDER_SUCCESS: 'GET_RESERVATIONS_BY_ORDER_SUCCESS',
  GET_RESERVATIONS_BY_ORDER_FAILURE: 'GET_RESERVATIONS_BY_ORDER_FAILURE',

  GET_MATERIALS_REQUEST: 'GET_MATERIALS_REQUEST',
  GET_MATERIALS_SUCCESS: 'GET_MATERIALS_SUCCESS',
  GET_MATERIALS_FAILURE: 'GET_MATERIALS_FAILURE',

  CREATE_MATERIAL_REQUEST: 'CREATE_MATERIAL_REQUEST',
  CREATE_MATERIAL_SUCCESS: 'CREATE_MATERIAL_SUCCESS',
  CREATE_MATERIAL_FAILURE: 'CREATE_MATERIAL_FAILURE',

  UPDATE_MATERIAL_REQUEST: 'UPDATE_MATERIAL_REQUEST',
  UPDATE_MATERIAL_SUCCESS: 'UPDATE_MATERIAL_SUCCESS',
  UPDATE_MATERIAL_FAILURE: 'UPDATE_MATERIAL_FAILURE',

  ARCHIVE_MATERIAL_REQUEST: 'ARCHIVE_MATERIAL_REQUEST',
  ARCHIVE_MATERIAL_SUCCESS: 'ARCHIVE_MATERIAL_SUCCESS',
  ARCHIVE_MATERIAL_FAILURE: 'ARCHIVE_MATERIAL_FAILURE',

  GET_STOCK_MOVEMENTS_REQUEST: 'GET_STOCK_MOVEMENTS_REQUEST',
  GET_STOCK_MOVEMENTS_SUCCESS: 'GET_STOCK_MOVEMENTS_SUCCESS',
  GET_STOCK_MOVEMENTS_FAILURE: 'GET_STOCK_MOVEMENTS_FAILURE',

  GET_BOM_PRODUCTS_REQUEST: 'GET_BOM_PRODUCTS_REQUEST',
  GET_BOM_PRODUCTS_SUCCESS: 'GET_BOM_PRODUCTS_SUCCESS',
  GET_BOM_PRODUCTS_FAILURE: 'GET_BOM_PRODUCTS_FAILURE',
};

export const notificationConstants = {
  SET_FILTERS: "USER_NOTIFICATIONS_SET_FILTERS",
  RESET_LIST: "USER_NOTIFICATIONS_RESET_LIST",

  FETCH_PAGE_REQUEST: "USER_NOTIFICATIONS_FETCH_PAGE_REQUEST",
  FETCH_PAGE_SUCCESS: "USER_NOTIFICATIONS_FETCH_PAGE_SUCCESS",
  FETCH_PAGE_FAILURE: "USER_NOTIFICATIONS_FETCH_PAGE_FAILURE",

  FETCH_COUNTS_REQUEST: "USER_NOTIFICATIONS_FETCH_COUNTS_REQUEST",
  FETCH_COUNTS_SUCCESS: "USER_NOTIFICATIONS_FETCH_COUNTS_SUCCESS",
  FETCH_COUNTS_FAILURE: "USER_NOTIFICATIONS_FETCH_COUNTS_FAILURE",

  RECEIVED: "USER_NOTIFICATION_RECEIVED",

  NOTIFICATION_MARK_READ_REQUEST: "USER_NOTIFICATION_MARK_READ_REQUEST",
  NOTIFICATION_MARK_READ: "USER_NOTIFICATION_MARK_READ",
  NOTIFICATION_MARK_READ_FAILURE: "USER_NOTIFICATION_MARK_READ_FAILURE",

  NOTIFICATION_MARK_ALL_READ_REQUEST: "USER_NOTIFICATION_MARK_ALL_READ_REQUEST",
  NOTIFICATION_MARK_ALL_READ: "USER_NOTIFICATION_MARK_ALL_READ",
  NOTIFICATION_MARK_ALL_READ_FAILURE: "USER_NOTIFICATION_MARK_ALL_READ_FAILURE",

  NOTIFICATION_REMOTE_READ: "USER_NOTIFICATION_REMOTE_READ",
  NOTIFICATION_REMOTE_READ_ALL: "USER_NOTIFICATION_REMOTE_READ_ALL",
};


export const callConstants = {
  INVITE: 'CALL_INVITE',
  INCOMING: 'CALL_INCOMING',
  CONNECTING: 'CALL_CONNECTING',
  CONNECTED: 'CALL_CONNECTED',
  TOGGLE_MIC: 'CALL_TOGGLE_MIC',
  TOGGLE_CAM: 'CALL_TOGGLE_CAM',
  ENDED: 'CALL_ENDED',
  ERROR: 'CALL_ERROR',
  PATCH_STATE: 'PATCH_STATE',
  MINIMIZE: 'CALL_MINIMIZE',
  RESTORE: 'CALL_RESTORE',
};

export const paymentOrderConstants = {
  INIT_PAYMENT_REQUEST: 'INIT_PAYMENT_REQUEST',
  INIT_PAYMENT_SUCCESS: 'INIT_PAYMENT_SUCCESS',
  INIT_PAYMENT_FAILURE: 'INIT_PAYMENT_FAILURE',
};


export const messageConstants = {
  MARK_MESSAGES_AS_READ_REQUEST: "MARK_MESSAGES_AS_READ_REQUEST",
  MARK_MESSAGES_AS_READ_SUCCESS: "MARK_MESSAGES_AS_READ_SUCCESS",
  MARK_MESSAGES_AS_READ_FAILURE: "MARK_MESSAGES_AS_READ_FAILURE",

  GET_MESSAGES_REQUEST: "GET_MESSAGES_REQUEST",
  GET_MESSAGES_SUCCESS: "GET_MESSAGES_SUCCESS",
  GET_MESSAGES_FAILURE: "GET_MESSAGES_FAILURE",

  GET_MESSAGES_OLDER_REQUEST: "GET_MESSAGES_OLDER_REQUEST",
  GET_MESSAGES_OLDER_SUCCESS: "GET_MESSAGES_OLDER_SUCCESS",
  GET_MESSAGES_OLDER_FAILURE: "GET_MESSAGES_OLDER_FAILURE",

  SEND_MESSAGE_REQUEST: "SEND_MESSAGE_REQUEST",
  SEND_MESSAGE_PROGRESS: "SEND_MESSAGE_PROGRESS",
  SEND_MESSAGE_SUCCESS: "SEND_MESSAGE_SUCCESS",
  SEND_MESSAGE_FAILURE: "SEND_MESSAGE_FAILURE",

  SEND_MESSAGE_OPTIMISTIC_ADD: "SEND_MESSAGE_OPTIMISTIC_ADD",
  SEND_MESSAGE_OPTIMISTIC_CONFIRM: "SEND_MESSAGE_OPTIMISTIC_CONFIRM",
  SEND_MESSAGE_OPTIMISTIC_FAILURE: "SEND_MESSAGE_OPTIMISTIC_FAILURE",

  FORWARD_MESSAGE_REQUEST: "FORWARD_MESSAGE_REQUEST",
  FORWARD_MESSAGE_SUCCESS: "FORWARD_MESSAGE_SUCCESS",
  FORWARD_MESSAGE_FAILURE: "FORWARD_MESSAGE_FAILURE",

  SEND_TEXT_SUCCESS: "SEND_TEXT_SUCCESS",
  SEND_FILE_SUCCESS: "SEND_FILE_SUCCESS",
  SEND_VOICE_SUCCESS: "SEND_VOICE_SUCCESS",

  CLEAR_MESSAGES: "CLEAR_MESSAGES",
  RECEIVE_NEW_MESSAGE: "RECEIVE_NEW_MESSAGE",

  DELETE_MESSAGE_REQUEST: "DELETE_MESSAGE_REQUEST",
  DELETE_MESSAGE_SUCCESS: "DELETE_MESSAGE_SUCCESS",
  DELETE_MESSAGE_FAILURE: "DELETE_MESSAGE_FAILURE",
};

export const chatConstants = {
  CREATE_CHAT_REQUEST: "CREATE_CHAT_REQUEST",
  CREATE_CHAT_SUCCESS: "CREATE_CHAT_SUCCESS",
  CREATE_CHAT_FAILURE: "CREATE_CHAT_FAILURE",

  FETCH_CHATS_REQUEST: "FETCH_CHATS_REQUEST",
  FETCH_CHATS_SUCCESS: "FETCH_CHATS_SUCCESS",
  FETCH_CHATS_FAILURE: "FETCH_CHATS_FAILURE",

  FETCH_MY_CHATS_REQUEST: "FETCH_MY_CHATS_REQUEST",
  FETCH_MY_CHATS_SUCCESS: "FETCH_MY_CHATS_SUCCESS",
  FETCH_MY_CHATS_FAILURE: "FETCH_MY_CHATS_FAILURE",

  CREATE_DM_REQUEST: "CREATE_DM_REQUEST",
  CREATE_DM_SUCCESS: "CREATE_DM_SUCCESS",
  CREATE_DM_FAILURE: "CREATE_DM_FAILURE",

  CREATE_ROOM_REQUEST: "CREATE_ROOM_REQUEST",
  CREATE_ROOM_SUCCESS: "CREATE_ROOM_SUCCESS",
  CREATE_ROOM_FAILURE: "CREATE_ROOM_FAILURE",

  SEND_MESSAGE_REQUEST: "SEND_MESSAGE_REQUEST",
  SEND_MESSAGE_SUCCESS: "SEND_MESSAGE_SUCCESS",
  SEND_MESSAGE_FAILURE: "SEND_MESSAGE_FAILURE",

  UPSERT_CHAT: "UPSERT_CHAT",
  REMOVE_CHAT: "REMOVE_CHAT",
  SET_ACTIVE_CHAT_ID: "SET_ACTIVE_CHAT_ID",
};

export const printFormConstants = {
  SET_PREVIEW_FORM_DATA: 'SET_PREVIEW_FORM_DATA',

  GET_PRINT_FORM_REQUEST: 'GET_PRINT_FORM_REQUEST',
  GET_PRINT_FORM_SUCCESS: 'GET_PRINT_FORM_SUCCESS',
  GET_PRINT_FORM_FAILURE: 'GET_PRINT_FORM_FAILURE',

  UPDATE_PRINT_FORM_REQUEST: 'UPDATE_PRINT_FORM_REQUEST',
  UPDATE_PRINT_FORM_SUCCESS: 'UPDATE_PRINT_FORM_SUCCESS',
  UPDATE_PRINT_FORM_FAILURE: 'UPDATE_PRINT_FORM_FAILURE',

  FINALIZE_PRINT_FORM_REQUEST: 'FINALIZE_PRINT_FORM_REQUEST',
  FINALIZE_PRINT_FORM_SUCCESS: 'FINALIZE_PRINT_FORM_SUCCESS',
  FINALIZE_PRINT_FORM_FAILURE: 'FINALIZE_PRINT_FORM_FAILURE',

  DELETE_PRINT_FORM_PDF_REQUEST: 'DELETE_PRINT_FORM_PDF_REQUEST',
  DELETE_PRINT_FORM_PDF_SUCCESS: 'DELETE_PRINT_FORM_PDF_SUCCESS',
  DELETE_PRINT_FORM_PDF_FAILURE: 'DELETE_PRINT_FORM_PDF_FAILURE',
}

export const officeConstants = {
  GET_PRODUCT_MODEL_DATA_PROGRESS: 'GET_PRODUCT_MODEL_DATA_PROGRESS',
  CLEAR_PRODUCT_MODEL_MODEL_PROGRESS: 'CLEAR_PRODUCT_MODEL_MODEL_PROGRESS',
  SET_CURRENT_OFFICE: "SET_CURRENT_OFFICE",
  UPDATE_CAMERA_POSITION: 'UPDATE_CAMERA_POSITION',
  SET_SELECTED_MODELS: 'SET_SELECTED_MODELS',
  SET_COLORS: 'SET_COLORS',

  GET_PRODUCT_MODEL_DATA_REQUEST: 'GET_PRODUCT_MODEL_DATA_REQUEST',
  GET_PRODUCT_MODEL_DATA_SUCCESS: 'GET_PRODUCT_MODEL_DATA_SUCCESS',
  GET_PRODUCT_MODEL_DATA_FAILURE: 'GET_PRODUCT_MODEL_DATA_FAILURE',

  CHECK_OFFICE_ACCESS_REQUEST: 'CHECK_OFFICE_ACCESS_REQUEST',
  CHECK_OFFICE_ACCESS_SUCCESS: 'CHECK_OFFICE_ACCESS_SUCCESS',
  CHECK_OFFICE_ACCESS_FAILURE: 'CHECK_OFFICE_ACCESS_FAILURE',

  GET_PRODUCTS_BY_CATEGORY_REQUEST: 'GET_PRODUCTS_BY_CATEGORY_REQUEST',
  GET_PRODUCTS_BY_CATEGORY_SUCCESS: 'GET_PRODUCTS_BY_CATEGORY_SUCCESS',
  GET_PRODUCTS_BY_CATEGORY_FAILURE: 'GET_PRODUCTS_BY_CATEGORY_FAILURE',

  GET_OFFICES_REQUEST: 'GET_OFFICES_REQUEST',
  GET_OFFICES_SUCCESS: 'GET_OFFICES_SUCCESS',
  GET_OFFICES_FAILURE: 'GET_OFFICES_FAILURE',

  CREATE_OFFICE_REQUEST: 'CREATE_OFFICE_REQUEST',
  CREATE_OFFICE_SUCCESS: 'CREATE_OFFICE_SUCCESS',
  CREATE_OFFICE_FAILURE: 'CREATE_OFFICE_FAILURE',

  UPDATE_OFFICE_REQUEST: 'UPDATE_OFFICE_REQUEST',
  UPDATE_OFFICE_SUCCESS: 'UPDATE_OFFICE_SUCCESS',
  UPDATE_OFFICE_FAILURE: 'UPDATE_OFFICE_FAILURE',

  PATCH_OFFICE_BILLING_SUMMARY: 'PATCH_OFFICE_BILLING_SUMMARY',

  UPDATE_OFFICE_USERS_REQUEST: 'UPDATE_OFFICE_USERS_REQUEST',
  UPDATE_OFFICE_USERS_SUCCESS: 'UPDATE_OFFICE_USERS_SUCCESS',
  UPDATE_OFFICE_USERS_FAILURE: 'UPDATE_OFFICE_USERS_FAILURE',

  GET_OFFICE_CATEGORIES_REQUEST: 'GET_OFFICE_CATEGORIES_REQUEST',
  GET_OFFICE_CATEGORIES_SUCCESS: 'GET_OFFICE_CATEGORIES_SUCCESS',
  GET_OFFICE_CATEGORIES_FAILURE: 'GET_OFFICE_CATEGORIES_FAILURE',

  UPDATE_PRODUCT_PRICE_REQUEST: 'UPDATE_PRODUCT_PRICE_REQUEST',
  UPDATE_PRODUCT_PRICE_SUCCESS: 'UPDATE_PRODUCT_PRICE_SUCCESS',
  UPDATE_PRODUCT_PRICE_FAILURE: 'UPDATE_PRODUCT_PRICE_FAILURE',
};

export const officeOwnerConstants = {
  CREATE_OFFICE_OWNER_REQUEST: 'CREATE_OFFICE_OWNER_REQUEST',
  CREATE_OFFICE_OWNER_SUCCESS: 'CREATE_OFFICE_OWNER_SUCCESS',
  CREATE_OFFICE_OWNER_FAILURE: 'CREATE_OFFICE_OWNER_FAILURE',

  GET_OFFICE_OWNERS_REQUEST: 'GET_OFFICE_OWNERS_REQUEST',
  GET_OFFICE_OWNERS_SUCCESS: 'GET_OFFICE_OWNERS_SUCCESS',
  GET_OFFICE_OWNERS_FAILURE: 'GET_OFFICE_OWNERS_FAILURE',

  GET_OFFICE_OWNER_REQUEST: 'GET_OFFICE_OWNER_REQUEST',
  GET_OFFICE_OWNER_SUCCESS: 'GET_OFFICE_OWNER_SUCCESS',
  GET_OFFICE_OWNER_FAILURE: 'GET_OFFICE_OWNER_FAILURE',

  UPDATE_OFFICE_OWNER_REQUEST: 'UPDATE_OFFICE_OWNER_REQUEST',
  UPDATE_OFFICE_OWNER_SUCCESS: 'UPDATE_OFFICE_OWNER_SUCCESS',
  UPDATE_OFFICE_OWNER_FAILURE: 'UPDATE_OFFICE_OWNER_FAILURE',

  DELETE_OFFICE_OWNER_REQUEST: 'DELETE_OFFICE_OWNER_REQUEST',
  DELETE_OFFICE_OWNER_SUCCESS: 'DELETE_OFFICE_OWNER_SUCCESS',
  DELETE_OFFICE_OWNER_FAILURE: 'DELETE_OFFICE_OWNER_FAILURE',
};


export const elementPaymentPageConstants = {
  GET_ELEMENT_PAYMENT_PAGE_REQUEST: "GET_ELEMENT_PAYMENT_PAGE_REQUEST",
  GET_ELEMENT_PAYMENT_PAGE_SUCCESS: "GET_ELEMENT_PAYMENT_PAGE_SUCCESS",
  GET_ELEMENT_PAYMENT_PAGE_FAILURE: "GET_ELEMENT_PAYMENT_PAGE_FAILURE",
};

export const publicFeaturedProductItemConstants = {
  GET_PUBLIC_FEATURED_PRODUCT_ITEM_REQUEST: "GET_PUBLIC_FEATURED_PRODUCT_ITEM_REQUEST",
  GET_PUBLIC_FEATURED_PRODUCT_ITEM_SUCCESS: "GET_PUBLIC_FEATURED_PRODUCT_ITEM_SUCCESS",
  GET_PUBLIC_FEATURED_PRODUCT_ITEM_FAILURE: "GET_PUBLIC_FEATURED_PRODUCT_ITEM_FAILURE",
  RESET_PUBLIC_FEATURED_PRODUCT_ITEM: "RESET_PUBLIC_FEATURED_PRODUCT_ITEM",
};

export const productListLinkConstants = {
  GET_BY_ID_PRODUCT_LIST_LINK_REQUEST: "GET_BY_ID_PRODUCT_LIST_LINK_REQUEST",
  GET_BY_ID_PRODUCT_LIST_LINK_SUCCESS: "GET_BY_ID_PRODUCT_LIST_LINK_SUCCESS",
  GET_BY_ID_PRODUCT_LIST_LINK_FAILURE: "GET_BY_ID_PRODUCT_LIST_LINK_FAILURE",
};

export const partnerProfileConstants = {
  GET_FENCE_MODELS_BY_CATEGORY_REQUEST: 'GET_FENCE_MODELS_BY_CATEGORY_REQUEST',
  GET_FENCE_MODELS_BY_CATEGORY_SUCCESS: 'GET_FENCE_MODELS_BY_CATEGORY_SUCCESS',
  GET_FENCE_MODELS_BY_CATEGORY_FAILURE: 'GET_FENCE_MODELS_BY_CATEGORY_FAILURE',

  GET_FENCING_BY_NAME_REQUEST: 'GET_FENCING_BY_NAME_REQUEST',
  GET_FENCING_BY_NAME_SUCCESS: 'GET_FENCING_BY_NAME_SUCCESS',
  GET_FENCING_BY_NAME_FAILURE: 'GET_FENCING_BY_NAME_FAILURE',
  LOAD_MODEL_GEOMETRY_REQUEST: 'LOAD_MODEL_GEOMETRY_REQUEST',
  LOAD_MODEL_GEOMETRY_SUCCESS: 'LOAD_MODEL_GEOMETRY_SUCCESS',
  LOAD_MODEL_GEOMETRY_FAILURE: 'LOAD_MODEL_GEOMETRY_FAILURE',
  RESET_PARTNER_PROFILE: 'RESET_PARTNER_PROFILE', // Новое действие
};

export const sceneConstants = {
  SET_SHOW_PIVOT: 'SCENE/SET_SHOW_PIVOT',
  REQUEST_PIVOT_PRESET: 'SCENE/REQUEST_PIVOT_PRESET',
  CLEAR_PIVOT_REQUEST: 'SCENE/CLEAR_PIVOT_REQUEST',
  APPLY_PIVOT_PRESET_RESOLVED: 'SCENE/APPLY_PIVOT_PRESET_RESOLVED',
  SET_PIVOT_PRESET_STATE: 'SCENE/SET_PIVOT_PRESET_STATE',

  SET_SHOW_TEXT_DIMENSIONS: 'SCENE/SET_SHOW_TEXT_DIMENSIONS',
  UPSERT_PRODUCTS_META: 'UPSERT_PRODUCTS_META',
  SET_FLOOR_VISIBLE: 'SET_FLOOR_VISIBLE',
  SET_FLOOR_MODE: 'SET_FLOOR_MODE',
  SET_FLOOR_COLOR: 'SET_FLOOR_COLOR',

  SET_SELECTED_MODEL_PATHS: 'SET_SELECTED_MODEL_PATHS',
  TOGGLE_MULTI_SELECT_MODE: 'TOGGLE_MULTI_SELECT_MODE',
  UPSERT_SELECTION_GROUP: 'UPSERT_SELECTION_GROUP',
  SET_ACTIVE_SELECTION_GROUP: 'SET_ACTIVE_SELECTION_GROUP',

  SET_MOVE_MODE: 'SET_MOVE_MODE',
  SET_MOVE_STEP: 'SET_MOVE_STEP',
  SET_CTRL_PRESSED: 'SET_CTRL_PRESSED',
  SET_KARKAS_AND_FENCE_COLOR: 'SET_KARKAS_AND_FENCE_COLOR',
  SET_COLORS: 'SET_COLORS',
  SET_MONUMENT_POLISHED: 'SET_MONUMENT_POLISHED',
  SET_DIMENSIONS: 'SET_DIMENSIONS',
  SET_PIVOT_POINT: 'SET_PIVOT_POINT',
  SET_SELECTED_MODEL: 'SET_SELECTED_MODEL',
  SET_POSITIONS: 'SET_POSITIONS',
  SET_SCALES: 'SET_SCALES',
  SET_ROTATIONS: 'SET_ROTATIONS',
  SET_MODEL_PATHS: 'SET_MODEL_PATHS',
  SET_SELECTED_MODELS: 'SET_SELECTED_MODELS',
  SET_FENCE_COLOR: 'SET_FENCE_COLOR',
  SET_SCENE_COLOR: 'SET_SCENE_COLOR',
  SET_GRID_VISIBLE: 'SET_GRID_VISIBLE',
  SET_GRID_COLOR: 'SET_GRID_COLOR',
  SET_GRID_POSITION: 'SET_GRID_POSITION',
  SET_MIN_Z: 'SET_MIN_Z',
  SET_PROCESSED_PHOTO: 'SET_PROCESSED_PHOTO',
  SET_HEAD_CENTER: 'SET_HEAD_CENTER',
  SET_SHOW_DIMENSION_LINES: 'SET_SHOW_DIMENSION_LINES',
  SET_LINE_THICKNESS: 'SET_LINE_THICKNESS',
  SET_FONT_SIZE: 'SET_FONT_SIZE',
  SET_LINE_COLOR: 'SET_LINE_COLOR',
  SET_CAMERA_STATE: 'SET_CAMERA_STATE',
  TOGGLE_HIDDEN_MODEL: 'TOGGLE_HIDDEN_MODEL',

  SET_CUSTOM_OBJECTS: 'SET_CUSTOM_OBJECTS',
  CUSTOM_OBJECT_CREATE: 'CUSTOM_OBJECT_CREATE',
  CUSTOM_OBJECT_UPDATE: 'CUSTOM_OBJECT_UPDATE',
  CUSTOM_OBJECT_DELETE: 'CUSTOM_OBJECT_DELETE',

  SET_TRANSFORM_MODE: 'SET_TRANSFORM_MODE',
  SET_TEXTURE_EDIT_MODE: 'SET_TEXTURE_EDIT_MODE',

  SCENE_HISTORY_COMMIT: 'SCENE_HISTORY_COMMIT',
  SCENE_HISTORY_UNDO: 'SCENE_HISTORY_UNDO',
  SCENE_HISTORY_REDO: 'SCENE_HISTORY_REDO',

  SET_SUN_ANGLE: 'SCENE/SET_SUN_ANGLE',
  SET_SUN_VERTICAL: 'SCENE/SET_SUN_VERTICAL',
  SET_SUN_INTENSITY: 'SCENE/SET_SUN_INTENSITY',

  SET_SHADOWS_ENABLED: 'SCENE/SET_SHADOWS_ENABLED',
  SET_GRAPHICS_QUALITY: 'SCENE/SET_GRAPHICS_QUALITY', // <-- ДОБАВЛЕНО
}

export const contactMConstants = {
  GET_CONTACT_M_REQUEST: "GET_CONTACT_M_REQUEST",
  GET_CONTACT_M_SUCCESS: "GET_CONTACT_M_SUCCESS",
  GET_CONTACT_M_FAILURE: "GET_CONTACT_M_FAILURE",
};

export const galleryImgUserConstants = {
  ADD_TO_GALLERY_IMG_REQUEST: "ADD_TO_GALLERY_IMG_REQUEST",
  ADD_TO_GALLERY_IMG_SUCCESS: "ADD_TO_GALLERY_IMG_SUCCESS",
  ADD_TO_GALLERY_IMG_FAILURE: "ADD_TO_GALLERY_IMG_FAILURE",

  GET_GALLERY_IMAGES_REQUEST: "GET_GALLERY_IMAGES_REQUEST",
  GET_GALLERY_IMAGES_SUCCESS: "GET_GALLERY_IMAGES_SUCCESS",
  GET_GALLERY_IMAGES_FAILURE: "GET_GALLERY_IMAGES_FAILURE",

  GET_BY_ID_REQUEST: "GET_BY_ID_REQUEST",
  GET_BY_ID_SUCCESS: "GET_BY_ID_SUCCESS",
  GET_BY_ID_FAILURE: "GET_BY_ID_FAILURE",

  REMOVE_ITEM_REQUEST: "REMOVE_ITEM_REQUEST",
  REMOVE_ITEM_SUCCESS: "REMOVE_ITEM_SUCCESS",
  REMOVE_ITEM_FAILURE: "REMOVE_ITEM_FAILURE",

  CLOSE_ALERT_SUCCESS: "CLOSE_ALERT_SUCCESS",
}

export const applicationGalleryConstants = {
  CREATE_APPLICATION_GALLERY_REQUEST: "CREATE_APPLICATION_GALLERY_REQUEST",
  CREATE_APPLICATION_GALLERY_SUCCESS: "CREATE_APPLICATION_GALLERY_SUCCESS",
  CREATE_APPLICATION_GALLERY_FAILURE: "CREATE_APPLICATION_GALLERY_FAILURE",

  GET_BY_USER_REQUEST: "GET_BY_USER_REQUEST",
  GET_BY_USER_SUCCESS: "GET_BY_USER_SUCCESS",
  GET_BY_USER_FAILURE: "GET_BY_USER_FAILURE",

  GET_BY_ID_REQUEST: "GET_BY_ID_REQUEST",
  GET_BY_ID_SUCCESS: "GET_BY_ID_SUCCESS",
  GET_BY_ID_FAILURE: "GET_BY_ID_FAILURE",
}
export const roleChangeRequest = {
  CREATE_ROLE_CHANGE_REQUEST: "CREATE_ROLE_CHANGE_REQUEST",
  CREATE_ROLE_CHANGE_SUCCESS: "CREATE_ROLE_CHANGE_SUCCESS",
  CREATE_ROLE_CHANGE_FAILURE: "CREATE_ROLE_CHANGE_FAILURE",

  GET_ROLE_CHANGE_BY_USER_REQUEST: "GET_ROLE_CHANGE_BY_USER_REQUEST",
  GET_ROLE_CHANGE_BY_USER_SUCCESS: "GET_ROLE_CHANGE_BY_USER_SUCCESS",
  GET_ROLE_CHANGE_BY_USER_FAILURE: "GET_ROLE_CHANGE_BY_USER_FAILURE",

  GET_OFFICE_ROLE_CHANGE_REQUESTS_REQUEST: "GET_OFFICE_ROLE_CHANGE_REQUESTS_REQUEST",
  GET_OFFICE_ROLE_CHANGE_REQUESTS_SUCCESS: "GET_OFFICE_ROLE_CHANGE_REQUESTS_SUCCESS",
  GET_OFFICE_ROLE_CHANGE_REQUESTS_FAILURE: "GET_OFFICE_ROLE_CHANGE_REQUESTS_FAILURE",

  UPDATE_ROLE_CHANGE_STATUS_REQUEST: "UPDATE_ROLE_CHANGE_STATUS_REQUEST",
  UPDATE_ROLE_CHANGE_STATUS_SUCCESS: "UPDATE_ROLE_CHANGE_STATUS_SUCCESS",
  UPDATE_ROLE_CHANGE_STATUS_FAILURE: "UPDATE_ROLE_CHANGE_STATUS_FAILURE",

  UPDATE_ROLE_CHANGE_VIEWED_REQUEST: "UPDATE_ROLE_CHANGE_VIEWED_REQUEST",
  UPDATE_ROLE_CHANGE_VIEWED_SUCCESS: "UPDATE_ROLE_CHANGE_VIEWED_SUCCESS",
  UPDATE_ROLE_CHANGE_VIEWED_FAILURE: "UPDATE_ROLE_CHANGE_VIEWED_FAILURE",

  DELETE_ROLE_CHANGE_REQUEST: "DELETE_ROLE_CHANGE_REQUEST",
  DELETE_ROLE_CHANGE_SUCCESS: "DELETE_ROLE_CHANGE_SUCCESS",
  DELETE_ROLE_CHANGE_FAILURE: "DELETE_ROLE_CHANGE_FAILURE",
}

export const mainActionsConstants = {
  GET_BY_ID_REQUEST: "GET_BY_ID_REQUEST",
  GET_BY_ID_SUCCESS: "GET_BY_ID_SUCCESS",
  GET_BY_ID_FAILURE: "GET_BY_ID_FAILURE",

  UPDATE_VIEW_BY_ID_REQUEST: "UPDATE_VIEW_BY_ID_REQUEST",
  UPDATE_VIEW_BY_ID_SUCCESS: "UPDATE_VIEW_BY_ID_SUCCESS",
  UPDATE_VIEW_BY_ID_FAILURE: "UPDATE_VIEW_BY_ID_FAILURE",

  GET_ALL_ITEMS_REQUEST: "GET_ALL_ITEMS_REQUEST",
  GET_ALL_ITEMS_SUCCESS: "GET_ALL_ITEMS_SUCCESS",
  GET_ALL_ITEMS_FAILURE: "GET_ALL_ITEMS_FAILURE",
}

export const regionConstants = {
  GET_REGION_REQUEST: "GET_REGION_REQUEST",
  GET_REGION_SUCCESS: "GET_REGION_SUCCESS",
  GET_REGION_FAILURE: "GET_REGION_FAILURE",

  GET_REGION_BY_ID_REQUEST: "GET_REGION_BY_ID_REQUEST",
  GET_REGION_BY_ID_SUCCESS: "GET_REGION_BY_ID_SUCCESS",
  GET_REGION_BY_ID_FAILURE: "GET_REGION_BY_ID_FAILURE",
}

export const pickupPointsConstants = {
  GET_PICKUP_POINTS_REQUEST: "GET_PICKUP_POINTS_REQUEST",
  GET_PICKUP_POINTS_SUCCESS: "GET_PICKUP_POINTS_SUCCESS",
  GET_PICKUP_POINTS_FAILURE: "GET_PICKUP_POINTS_FAILURE",
}

export const allQuestionConstants = {
  GET_ALL_QUESTION_REQUEST: "GET_ALL_QUESTION_REQUEST",
  GET_ALL_QUESTION_SUCCESS: "GET_ALL_QUESTION_SUCCESS",
  GET_ALL_QUESTION_FAILURE: "GET_ALL_QUESTION_FAILURE",
}

export const materialConstants = {
  GET_MATERIAL_REQUEST: "GET_MATERIAL_REQUEST",
  GET_MATERIAL_SUCCESS: "GET_MATERIAL_SUCCESS",
  GET_MATERIAL_FAILURE: "GET_MATERIAL_FAILURE",
}

export const partnerConstants = {
  GET_PARTNER_REQUEST: "GET_PARTNER_REQUEST",
  GET_PARTNER_SUCCESS: "GET_PARTNER_SUCCESS",
  GET_PARTNER_FAILURE: "GET_PARTNER_FAILURE",
  CREATE_PARTNER_REQUEST: "CREATE_PARTNER_REQUEST",
  CREATE_PARTNER_SUCCESS: "CREATE_PARTNER_SUCCESS",
  CREATE_PARTNER_FAILURE: "CREATE_PARTNER_FAILURE",
};

export const architectSkillsConstants = {
  GET_ARCHITECT_SKILLS_REQUEST: "GET_ARCHITECT_SKILLS_REQUEST",
  GET_ARCHITECT_SKILLS_SUCCESS: "GET_ARCHITECT_SKILLS_SUCCESS",
  GET_ARCHITECT_SKILLS_FAILURE: "GET_ARCHITECT_SKILLS_FAILURE",
};

export const architectLiConstants = {
  GET_ARCHITECT_LI_REQUEST: "GET_ARCHITECT_LI_REQUEST",
  GET_ARCHITECT_LI_SUCCESS: "GET_ARCHITECT_LI_SUCCESS",
  GET_ARCHITECT_LI_FAILURE: "GET_ARCHITECT_LI_FAILURE",
};

export const categoryConstants = {
  SHOW_CATEGORY_BLOCK: "SHOW_CATEGORY_BLOCK",
  HIDE_CATEGORY_BLOCK: "HIDE_CATEGORY_BLOCK",

  GET_ALL_CATEGORIES_REQUEST: "GET_ALL_CATEGORIES_REQUEST",
  GET_ALL_CATEGORIES_SUCCESS: "GET_ALL_CATEGORIES_SUCCESS",
  GET_ALL_CATEGORIES_FAILURE: "GET_ALL_CATEGORIES_FAILURE",

  GET_CATEGORY_DETAILS_BY_ID_REQUEST: "GET_CATEGORY_DETAILS_BY_ID_REQUEST",
  GET_CATEGORY_DETAILS_BY_ID_SUCCESS: "GET_CATEGORY_DETAILS_BY_ID_SUCCESS",
  GET_CATEGORY_DETAILS_BY_ID_FAILURE: "GET_CATEGORY_DETAILS_BY_ID_FAILURE",

  GET_CATEGORY_DETAILS_BY_SLUG_REQUEST: "GET_CATEGORY_DETAILS_BY_SLUG_REQUEST",
  GET_CATEGORY_DETAILS_BY_SLUG_SUCCESS: "GET_CATEGORY_DETAILS_BY_SLUG_SUCCESS",
  GET_CATEGORY_DETAILS_BY_SLUG_FAILURE: "GET_CATEGORY_DETAILS_BY_SLUG_FAILURE",
};

export const architectConstants = {
  GET_ARCHITECT_REQUEST: "GET_ARCHITECT_REQUEST",
  GET_ARCHITECT_SUCCESS: "GET_ARCHITECT_SUCCESS",
  GET_ARCHITECT_FAILURE: "GET_ARCHITECT_FAILURE",
};
export const benefitsConstants = {
  GET_BENEFITS_REQUEST: "GET_BENEFITS_REQUEST",
  GET_BENEFITS_SUCCESS: "GET_BENEFITS_SUCCESS",
  GET_BENEFITS_FAILURE: "GET_BENEFITS_FAILURE",
};
export const aboutUsConstants = {
  GET_ABOUT_US_REQUEST: "GET_ABOUT_US_REQUEST",
  GET_ABOUT_US_SUCCESS: "GET_ABOUT_US_SUCCESS",
  GET_ABOUT_US_FAILURE: "GET_ABOUT_US_FAILURE",
};

export const paymentListConstants = {
  GET_PAYMENT_LIST_REQUEST: "GET_PAYMENT_LIST_REQUEST",
  GET_PAYMENT_LIST_SUCCESS: "GET_PAYMENT_LIST_SUCCESS",
  GET_PAYMENT_LIST_FAILURE: "GET_PAYMENT_LIST_FAILURE",
};

export const deliveryInfoConstants = {
  GET_DELIVERY_INFO_REQUEST: "GET_DELIVERY_INFO_REQUEST",
  GET_DELIVERY_INFO_SUCCESS: "GET_DELIVERY_INFO_SUCCESS",
  GET_DELIVERY_INFO_FAILURE: "GET_DELIVERY_INFO_FAILURE",

};

export const blogConstants = {
  GET_ALL_BLOG_REQUEST: "GET_ALL_BLOG_REQUEST",
  GET_ALL_BLOG_SUCCESS: "GET_ALL_BLOG_SUCCESS",
  GET_ALL_BLOG_FAILURE: "GET_ALL_BLOG_FAILURE",

  GET_BLOG_DETAILS_BY_ID_REQUEST: "GET_BLOG_DETAILS_BY_ID_REQUEST",
  GET_BLOG_DETAILS_BY_ID_SUCCESS: "GET_BLOG_DETAILS_BY_ID_SUCCESS",
  GET_BLOG_DETAILS_BY_ID_FAILURE: "GET_BLOG_DETAILS_BY_ID_FAILURE",
};
export const warrantyConstants = {
  GET_ALL_WARRANTY_REQUEST: "GET_ALL_WARRANTY_REQUEST",
  GET_ALL_WARRANTY_SUCCESS: "GET_ALL_WARRANTY_SUCCESS",
  GET_ALL_WARRANTY_FAILURE: "GET_ALL_WARRANTY_FAILURE",

};

export const portfolioConstants = {

  GET_ALL_PORTFOLIO_REQUEST: "GET_ALL_PORTFOLIO_REQUEST",
  GET_ALL_PORTFOLIO_SUCCESS: "GET_ALL_PORTFOLIO_SUCCESS",
  GET_ALL_PORTFOLIO_FAILURE: "GET_ALL_PORTFOLIO_FAILURE",
  GET_PORTFOLIO_BY_SLUG_REQUEST: "GET_PORTFOLIO_BY_SLUG_REQUEST",
  GET_PORTFOLIO_BY_SLUG_SUCCESS: "GET_PORTFOLIO_BY_SLUG_SUCCESS",
  GET_PORTFOLIO_BY_SLUG_FAILURE: "GET_PORTFOLIO_BY_SLUG_FAILURE",
  GET_PORTFOLIO_PAGE_REQUEST: "GET_PORTFOLIO_PAGE_REQUEST",
  GET_PORTFOLIO_PAGE_SUCCESS: "GET_PORTFOLIO_PAGE_SUCCESS",
  GET_PORTFOLIO_PAGE_FAILURE: "GET_PORTFOLIO_PAGE_FAILURE",

  GET_PORTFOLIO_DETAILS_BY_ID_REQUEST: "GET_PORTFOLIO_DETAILS_BY_ID_REQUEST",
  GET_PORTFOLIO_DETAILS_BY_ID_SUCCESS: "GET_PORTFOLIO_DETAILS_BY_ID_SUCCESS",
  GET_PORTFOLIO_DETAILS_BY_ID_FAILURE: "GET_PORTFOLIO_DETAILS_BY_ID_FAILURE",
  SET_VIEW: "SET_VIEW"
};

export const productConstants = {
  CLEAR_PRODUCT_DETAILS: "CLEAR_PRODUCT_DETAILS",
  SET_SEARCH_NAME: "SET_SEARCH_NAME",
  SET_OPEN_SEARCH_MODAL_PRODUCT: "SET_OPEN_SEARCH_MODAL_PRODUCT",
  SET_CURRENT_IMG_SLIDER_SUCCESS: "SET_CURRENT_IMG_SLIDER_SUCCESS",
  SET_PRODUCT_DETAILS_LIST: "SET_PRODUCT_DETAILS_LIST",
  UPDATE_PRODUCT_LIST: "UPDATE_PRODUCT_LIST",

  GET_GALLERY_PRODUCTS_REQUEST: "GET_GALLERY_PRODUCTS_REQUEST",
  GET_GALLERY_PRODUCTS_SUCCESS: "GET_GALLERY_PRODUCTS_SUCCESS",
  GET_GALLERY_PRODUCTS_FAILURE: "GET_GALLERY_PRODUCTS_FAILURE",

  GET_ALL_PRODUCTS_REQUEST: "GET_ALL_PRODUCTS_REQUEST",
  GET_ALL_PRODUCTS_SUCCESS: "GET_ALL_PRODUCTS_SUCCESS",
  GET_ALL_PRODUCTS_FAILURE: "GET_ALL_PRODUCTS_FAILURE",

  GET_PRODUCTS_BY_SLUG_REQUEST: "GET_PRODUCTS_BY_SLUG_REQUEST",
  GET_PRODUCTS_BY_SLUG_SUCCESS: "GET_PRODUCTS_BY_SLUG_SUCCESS",
  GET_PRODUCTS_BY_SLUG_FAILURE: "GET_PRODUCTS_BY_SLUG_FAILURE",

  GET_PRODUCT_PAGE_REQUEST: "GET_PRODUCT_PAGE_REQUEST",
  GET_PRODUCT_PAGE_SUCCESS: "GET_PRODUCT_PAGE_SUCCESS",
  GET_PRODUCT_PAGE_FAILURE: "GET_PRODUCT_PAGE_FAILURE",

  UPDATE_PRODUCT_VIEW_REQUEST: "UPDATE_PRODUCT_VIEW_REQUEST",
  UPDATE_PRODUCT_VIEW_SUCCESS: "UPDATE_PRODUCT_VIEW_SUCCESS",
  UPDATE_PRODUCT_VIEW_FAILURE: "UPDATE_PRODUCT_VIEW_FAILURE",

  GET_PRODUCT_DETAILS_BY_ID_REQUEST: "GET_PRODUCT_DETAILS_BY_ID_REQUEST",
  GET_PRODUCT_DETAILS_BY_ID_SUCCESS: "GET_PRODUCT_DETAILS_BY_ID_SUCCESS",
  GET_PRODUCT_DETAILS_BY_ID_FAILURE: "GET_PRODUCT_DETAILS_BY_ID_FAILURE",
  SET_PER_PAGE_REQUEST: "SET_PER_PAGE_REQUEST",
  SET_PER_PAGE_SUCCESS: "SET_PER_PAGE_SUCCESS",
  SET_PER_PAGE_FAILURE: "SET_PER_PAGE_FAILURE",

  VISIBLE_PRODUCT_BUY_BUTTON: "VISIBLE_PRODUCT_BUY_BUTTON",
  SET_PRODUCT_SEARCH_TYPE: "SET_PRODUCT_SEARCH_TYPE",
  SET_VIEW: "SET_VIEW",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  SET_CURRENT_CATEGORY: "SET_CURRENT_CATEGORY",
  SET_PAGE_SIZE_SUCCESS: "SET_PAGE_SIZE_SUCCESS",
  SET_ACTIVE_CATEGORY: "SET_ACTIVE_CATEGORY",
  CLOSE_ALERT_TO_PRODUCT_SUCCESS: "CLOSE_ALERT_TO_PRODUCT_SUCCESS",

  SEARCH_PRODUCTS_REQUEST: "SEARCH_PRODUCTS_REQUEST",
  SEARCH_PRODUCTS_SUCCESS: "SEARCH_PRODUCTS_SUCCESS",
  SEARCH_PRODUCTS_FAILURE: "SEARCH_PRODUCTS_FAILURE",

};
export const authConstants = {
  UPDATE_USER_BALANCE: 'UPDATE_USER_BALANCE',
  UPDATE_USER_SUBSCRIPTION: 'UPDATE_USER_SUBSCRIPTION',
  LOGOUT_BY_SESSION_EXPIRED: "LOGOUT_BY_SESSION_EXPIRED",
  SHOW_SETTING_MODAL: "SHOW_SETTING_MODAL",
  SET_CLOSE_ALERT: "SET_CLOSE_ALERT",
  SHOW_SEARCH_SHOW: "SHOW_SEARCH_SHOW",

  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",

  LOGOUT_REQUEST: "LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAILURE: "LOGOUT_FAILURE",

  SIGNUP_REQUEST: "SIGNUP_REQUEST",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
  SIGNUP_FAILURE: "SIGNUP_FAILURE",

  SHOW_MODAL_USER: "SHOW_MODAL_USER",
  SHOW_PASSWORD_RESET_MODAL: "SHOW_PASSWORD_RESET_MODAL",

  EMAIL_VERIFICATION_SEND_REQUEST: "EMAIL_VERIFICATION_SEND_REQUEST",
  EMAIL_VERIFICATION_SEND_SUCCESS: "EMAIL_VERIFICATION_SEND_SUCCESS",
  EMAIL_VERIFICATION_SEND_FAILURE: "EMAIL_VERIFICATION_SEND_FAILURE",

  EMAIL_VERIFICATION_CONFIRM_REQUEST: "EMAIL_VERIFICATION_CONFIRM_REQUEST",
  EMAIL_VERIFICATION_CONFIRM_SUCCESS: "EMAIL_VERIFICATION_CONFIRM_SUCCESS",
  EMAIL_VERIFICATION_CONFIRM_FAILURE: "EMAIL_VERIFICATION_CONFIRM_FAILURE",

  PASSWORD_RESET_REQUEST_REQUEST: "PASSWORD_RESET_REQUEST_REQUEST",
  PASSWORD_RESET_REQUEST_SUCCESS: "PASSWORD_RESET_REQUEST_SUCCESS",
  PASSWORD_RESET_REQUEST_FAILURE: "PASSWORD_RESET_REQUEST_FAILURE",

  PASSWORD_RESET_CONFIRM_REQUEST: "PASSWORD_RESET_CONFIRM_REQUEST",
  PASSWORD_RESET_CONFIRM_SUCCESS: "PASSWORD_RESET_CONFIRM_SUCCESS",
  PASSWORD_RESET_CONFIRM_FAILURE: "PASSWORD_RESET_CONFIRM_FAILURE",
};

export const historyProductConstants = {
  ADD_TO_HISTORY_PRODUCT_REQUEST: "ADD_TO_HISTORY_PRODUCT_REQUEST",
  ADD_TO_HISTORY_PRODUCT_SUCCESS: "ADD_TO_HISTORY_PRODUCT_SUCCESS",
  ADD_TO_HISTORY_PRODUCT_FAILURE: "ADD_TO_HISTORY_PRODUCT_FAILURE",
  GET_TO_HISTORY_PRODUCT_REQUEST: "GET_TO_HISTORY_PRODUCT_REQUEST",
  GET_TO_HISTORY_PRODUCT_SUCCESS: "GET_TO_HISTORY_PRODUCT_SUCCESS",
  GET_TO_HISTORY_PRODUCT_FAILURE: "GET_TO_HISTORY_PRODUCT_FAILURE",
  RESET_HISTORY_PRODUCT: "RESET_HISTORY_PRODUCT",
  SHOW_MODAL_HP: "SHOW_MODAL_HP",
  CLOSE_ALERT_TO_HISTORY_PRODUCT: "CLOSE_ALERT_TO_HISTORY_PRODUCT",

  REMOVE_HISTORY_PRODUCT_REQUEST: "REMOVE_HISTORY_PRODUCT_REQUEST",
  REMOVE_HISTORY_PRODUCT_SUCCESS: "REMOVE_HISTORY_PRODUCT_SUCCESS",
  REMOVE_HISTORY_PRODUCT_FAILURE: "REMOVE_HISTORY_PRODUCT_FAILURE",
};

export const desiresConstants = {
  VISIBLE_DESIRES_LIKE_ICON: "VISIBLE_DESIRES_LIKE_ICON",
  CLOSE_ALERT_TO_DESIRES_SUCCESS: "CLOSE_ALERT_TO_DESIRES_SUCCESS",
  ADD_TO_DESIRES_REQUEST: "ADD_TO_DESIRES_REQUEST",
  ADD_TO_DESIRES_SUCCESS: "ADD_TO_DESIRES_SUCCESS",
  ADD_TO_DESIRES_FAILURE: "ADD_TO_DESIRES_FAILURE",

  GET_TO_DESIRES_REQUEST: "GET_TO_DESIRES_REQUEST",
  GET_TO_DESIRES_SUCCESS: "GET_TO_DESIRES_SUCCESS",
  GET_TO_DESIRES_FAILURE: "GET_TO_DESIRES_FAILURE",

  DELETE_ARRAY_DESIRES_REQUEST: "DELETE_ARRAY_DESIRES_REQUEST",
  DELETE_ARRAY_DESIRES_SUCCESS: "DELETE_ARRAY_DESIRES_SUCCESS",
  DELETE_ARRAY_DESIRES_FAILURE: "DELETE_ARRAY_DESIRES_FAILURE",

  RESET_DESIRES: "RESET_DESIRES",
  SHOW_MODAL_DESIRES: "SHOW_MODAL_DESIRES",

  REMOVE_DESIRES_ITEM_REQUEST: "REMOVE_DESIRES_ITEM_REQUEST",
  REMOVE_DESIRES_ITEM_SUCCESS: "REMOVE_DESIRES_ITEM_SUCCESS",
  REMOVE_DESIRES_ITEM_FAILURE: "REMOVE_DESIRES_ITEM_FAILURE",
};
// cart constants
export const cartConstants = {
  UPDATE_CART_ITEM_QUANTITY_REQUEST: 'UPDATE_CART_ITEM_QUANTITY_REQUEST',
  UPDATE_CART_ITEM_QUANTITY_SUCCESS: 'UPDATE_CART_ITEM_QUANTITY_SUCCESS',
  UPDATE_CART_ITEM_QUANTITY_FAILURE: 'UPDATE_CART_ITEM_QUANTITY_FAILURE',

  UPDATE_CART_ITEM_CONFIG_REQUEST: 'UPDATE_CART_ITEM_CONFIG_REQUEST',
  UPDATE_CART_ITEM_CONFIG_SUCCESS: 'UPDATE_CART_ITEM_CONFIG_SUCCESS',
  UPDATE_CART_ITEM_CONFIG_FAILURE: 'UPDATE_CART_ITEM_CONFIG_FAILURE',

  ADD_TO_CART_REQUEST: 'ADD_TO_CART_REQUEST',
  ADD_TO_CART_SUCCESS: 'ADD_TO_CART_SUCCESS',
  ADD_TO_CART_FAILURE: 'ADD_TO_CART_FAILURE',

  GET_CART_ITEMS_REQUEST: 'GET_CART_ITEMS_REQUEST',
  GET_CART_ITEMS_SUCCESS: 'GET_CART_ITEMS_SUCCESS',
  GET_CART_ITEMS_FAILURE: 'GET_CART_ITEMS_FAILURE',

  UPDATE_TO_CART_SUCCESS: 'UPDATE_TO_CART_SUCCESS',
  FILTER_CART_ID: 'FILTER_CART_ID',
  SET_CLOSE_ALERT: 'SET_CLOSE_ALERT',
  RESET_CART: 'RESET_CART',
  SHOW_MODAL_CART: 'SHOW_MODAL_CART',
  SHOW_MODAL_CART_FALSE: 'SHOW_MODAL_CART_FALSE',

  REMOVE_CART_ITEM_REQUEST: 'REMOVE_CART_ITEM_REQUEST',
  REMOVE_CART_ITEM_SUCCESS: 'REMOVE_CART_ITEM_SUCCESS',
  REMOVE_CART_ITEM_FAILURE: 'REMOVE_CART_ITEM_FAILURE',
}
// actions/constants.js
// orderConstants
export const orderConstants = {
  ADD_USER_ORDER_REQUEST: "ADD_USER_ORDER_REQUEST",
  ADD_USER_ORDER_SUCCESS: "ADD_USER_ORDER_SUCCESS",
  ADD_USER_ORDER_FAILURE: "ADD_USER_ORDER_FAILURE",

  ADD_USER_ORDER_WITH_SCREENS_REQUEST: "ADD_USER_ORDER_WITH_SCREENS_REQUEST",
  ADD_USER_ORDER_WITH_SCREENS_SUCCESS: "ADD_USER_ORDER_WITH_SCREENS_SUCCESS",
  ADD_USER_ORDER_WITH_SCREENS_FAILURE: "ADD_USER_ORDER_WITH_SCREENS_FAILURE",

  SEARCH_ORDERS_BY_ORDER_NUMBER_REQUEST: "SEARCH_ORDERS_BY_ORDER_NUMBER_REQUEST",
  SEARCH_ORDERS_BY_ORDER_NUMBER_SUCCESS: "SEARCH_ORDERS_BY_ORDER_NUMBER_SUCCESS",
  SEARCH_ORDERS_BY_ORDER_NUMBER_FAILURE: "SEARCH_ORDERS_BY_ORDER_NUMBER_FAILURE",

  UPDATE_ORDER_BY_ID_VISIBLE_REQUEST: "UPDATE_ORDER_BY_ID_VISIBLE_REQUEST",
  UPDATE_ORDER_BY_ID_VISIBLE_SUCCESS: "UPDATE_ORDER_BY_ID_VISIBLE_SUCCESS",
  UPDATE_ORDER_BY_ID_VISIBLE_FAILURE: "UPDATE_ORDER_BY_ID_VISIBLE_FAILURE",

  GET_USER_ORDER_REQUEST: "GET_USER_ORDER_REQUEST",
  GET_USER_ORDER_SUCCESS: "GET_USER_ORDER_SUCCESS",
  GET_USER_ORDER_FAILURE: "GET_USER_ORDER_FAILURE",

  GET_USER_ORDER_DETAILS_REQUEST: "GET_USER_ORDER_DETAILS_REQUEST",
  GET_USER_ORDER_DETAILS_SUCCESS: "GET_USER_ORDER_DETAILS_SUCCESS",
  GET_USER_ORDER_DETAILS_FAILURE: "GET_USER_ORDER_DETAILS_FAILURE",

  CHANGE_ORDER_SCOPE_REQUEST: "CHANGE_ORDER_SCOPE_REQUEST",
  CHANGE_ORDER_SCOPE_SUCCESS: "CHANGE_ORDER_SCOPE_SUCCESS",
  CHANGE_ORDER_SCOPE_FAILURE: "CHANGE_ORDER_SCOPE_FAILURE",

  REQUEST_ORDER_ACCESS_REQUEST: "REQUEST_ORDER_ACCESS_REQUEST",
  REQUEST_ORDER_ACCESS_SUCCESS: "REQUEST_ORDER_ACCESS_SUCCESS",
  REQUEST_ORDER_ACCESS_FAILURE: "REQUEST_ORDER_ACCESS_FAILURE",

  GRANT_ORDER_ACCESS_REQUEST: "GRANT_ORDER_ACCESS_REQUEST",
  GRANT_ORDER_ACCESS_SUCCESS: "GRANT_ORDER_ACCESS_SUCCESS",
  GRANT_ORDER_ACCESS_FAILURE: "GRANT_ORDER_ACCESS_FAILURE",

  DECLINE_ORDER_ACCESS_REQUEST: "DECLINE_ORDER_ACCESS_REQUEST",
  DECLINE_ORDER_ACCESS_SUCCESS: "DECLINE_ORDER_ACCESS_SUCCESS",
  DECLINE_ORDER_ACCESS_FAILURE: "DECLINE_ORDER_ACCESS_FAILURE",

  SET_ORDER_MODE: "SET_ORDER_MODE",
  CLOSE_ALERT_TO_ORDER_SUCCESS: "CLOSE_ALERT_TO_ORDER_SUCCESS",
};

export const userConstants = {
  USER_UPDATE_SITE_THEME_TYPE_REQUEST: "USER_UPDATE_SITE_THEME_TYPE_REQUEST",
  USER_UPDATE_SITE_THEME_TYPE_SUCCESS: "USER_UPDATE_SITE_THEME_TYPE_SUCCESS",
  USER_UPDATE_SITE_THEME_TYPE_FAILURE: "USER_UPDATE_SITE_THEME_TYPE_FAILURE",

  USER_UPDATE_TRAFFIC_SAVING_REQUEST: "USER_UPDATE_TRAFFIC_SAVING_REQUEST",
  USER_UPDATE_TRAFFIC_SAVING_SUCCESS: "USER_UPDATE_TRAFFIC_SAVING_SUCCESS",
  USER_UPDATE_TRAFFIC_SAVING_FAILURE: "USER_UPDATE_TRAFFIC_SAVING_FAILURE",

  USER_UPDATE_NEWSLETTER_SETTINGS_REQUEST: "USER_UPDATE_NEWSLETTER_SETTINGS_REQUEST",
  USER_UPDATE_NEWSLETTER_SETTINGS_SUCCESS: "USER_UPDATE_NEWSLETTER_SETTINGS_SUCCESS",
  USER_UPDATE_NEWSLETTER_SETTINGS_FAILURE: "USER_UPDATE_NEWSLETTER_SETTINGS_FAILURE",

  USER_CHANGE_PASSWORD_REQUEST: "USER_CHANGE_PASSWORD_REQUEST",
  USER_CHANGE_PASSWORD_SUCCESS: "USER_CHANGE_PASSWORD_SUCCESS",
  USER_CHANGE_PASSWORD_FAILURE: "USER_CHANGE_PASSWORD_FAILURE",

  USER_EMAIL_CHANGE_REQUEST_REQUEST: "USER_EMAIL_CHANGE_REQUEST_REQUEST",
  USER_EMAIL_CHANGE_REQUEST_SUCCESS: "USER_EMAIL_CHANGE_REQUEST_SUCCESS",
  USER_EMAIL_CHANGE_REQUEST_FAILURE: "USER_EMAIL_CHANGE_REQUEST_FAILURE",

  USER_EMAIL_CHANGE_CONFIRM_REQUEST: "USER_EMAIL_CHANGE_CONFIRM_REQUEST",
  USER_EMAIL_CHANGE_CONFIRM_SUCCESS: "USER_EMAIL_CHANGE_CONFIRM_SUCCESS",
  USER_EMAIL_CHANGE_CONFIRM_FAILURE: "USER_EMAIL_CHANGE_CONFIRM_FAILURE",

  GET_USER_ADDRESS_REQUEST: "GET_USER_ADDRESS_REQUEST",
  GET_USER_ADDRESS_SUCCESS: "GET_USER_ADDRESS_SUCCESS",
  GET_USER_ADDRESS_FAILURE: "GET_USER_ADDRESS_FAILURE",

  ADD_USER_ADDRESS_REQUEST: "ADD_USER_ADDRESS_REQUEST",
  ADD_USER_ADDRESS_SUCCESS: "ADD_USER_ADDRESS_SUCCESS",
  ADD_USER_ADDRESS_FAILURE: "ADD_USER_ADDRESS_FAILURE",

  UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_REQUEST: "UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_REQUEST",
  UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_SUCCESS: "UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_SUCCESS",
  UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_FAILURE: "UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_FAILURE",

  UPDATE_USER_REGION_REQUEST: "UPDATE_USER_REGION_REQUEST",
  UPDATE_USER_REGION_SUCCESS: "UPDATE_USER_REGION_SUCCESS",
  UPDATE_USER_REGION_FAILURE: "UPDATE_USER_REGION_FAILURE",

  UPDATE_SUBSCRIBE_USER_BY_ID: "UPDATE_SUBSCRIBE_USER_BY_ID"
};


export const filterConstants = {
  SET_SORT_BY: "SET_SORT_BY"
}


export const applicationChangeProfileConstants = {
  SET_MODAL_TYPE_APPLICATION_CHANGE_PROFILE: "SET_MODAL_TYPE_APPLICATION_CHANGE_PROFILE",
  VISIBLE_REGISTER_MODAL_APPLICATION_CHANGE_PROFILE: "VISIBLE_REGISTER_MODAL_APPLICATION_CHANGE_PROFILE",
  PASSWORDS_MATCH_APPLICATION_CHANGE_PROFILE_SUCCESS: "PASSWORDS_MATCH_APPLICATION_CHANGE_PROFILE_SUCCESS",

  CREATE_APPLICATION_CHANGE_PROFILE_REQUEST: "CREATE_APPLICATION_CHANGE_PROFILE_REQUEST",
  CREATE_APPLICATION_CHANGE_PROFILE_SUCCESS: "CREATE_APPLICATION_CHANGE_PROFILE_SUCCESS",
  CREATE_APPLICATION_CHANGE_PROFILE_FAILURE: "CREATE_APPLICATION_CHANGE_PROFILE_FAILURE",

  GET_APPLICATION_CHANGE_PROFILE_BY_USER_REQUEST: "GET_APPLICATION_CHANGE_PROFILE_BY_USER_REQUEST",
  GET_APPLICATION_CHANGE_PROFILE_BY_USER_SUCCESS: "GET_APPLICATION_CHANGE_PROFILE_BY_USER_SUCCESS",
  GET_APPLICATION_CHANGE_PROFILE_BY_USER_FAILURE: "GET_APPLICATION_CHANGE_PROFILE_BY_USER_FAILURE",

  GET_APPLICATION_CHANGE_PROFILE_BY_ID_REQUEST: "GET_APPLICATION_CHANGE_PROFILE_BY_ID_REQUEST",
  GET_APPLICATION_CHANGE_PROFILE_BY_ID_SUCCESS: "GET_APPLICATION_CHANGE_PROFILE_BY_ID_SUCCESS",
  GET_APPLICATION_CHANGE_PROFILE_BY_ID_FAILURE: "GET_APPLICATION_CHANGE_PROFILE_BY_ID_FAILURE",

  ADD_SAMPLE_PHOTO_REQUEST: "ADD_SAMPLE_PHOTO_REQUEST",
  ADD_SAMPLE_PHOTO_SUCCESS: "ADD_SAMPLE_PHOTO_SUCCESS",
  ADD_SAMPLE_PHOTO_FAILURE: "ADD_SAMPLE_PHOTO_FAILURE",

  CLOSE_ALERT_TO_APPLICATION_CHANGE_PROFILE: "CLOSE_ALERT_TO_APPLICATION_CHANGE_PROFILE",
}

export const applicationCallMeConstants = {
  SET_MODAL_TYPE_APPLICATION_CALL_ME: "SET_MODAL_TYPE_APPLICATION_CALL_ME",
  VISIBLE_REGISTER_MODAL_APPLICATION_CALL_ME: "VISIBLE_REGISTER_MODAL_APPLICATION_CALL_ME",
  PASSWORDS_MATCH_APPLICATION_CALL_ME_SUCCESS: "PASSWORDS_MATCH_APPLICATION_CALL_ME_SUCCESS",

  CREATE_APPLICATION_CALL_ME_REQUEST: "CREATE_APPLICATION_CALL_ME_REQUEST",
  CREATE_APPLICATION_CALL_ME_SUCCESS: "CREATE_APPLICATION_CALL_ME_SUCCESS",
  CREATE_APPLICATION_CALL_ME_FAILURE: "CREATE_APPLICATION_CALL_ME_FAILURE",

  GET_APPLICATION_CALL_ME_BY_USER_REQUEST: "GET_APPLICATION_CALL_ME_BY_USER_REQUEST",
  GET_APPLICATION_CALL_ME_BY_USER_SUCCESS: "GET_APPLICATION_CALL_ME_BY_USER_SUCCESS",
  GET_APPLICATION_CALL_ME_BY_USER_FAILURE: "GET_APPLICATION_CALL_ME_BY_USER_FAILURE",

  ADD_SAMPLE_PHOTO_REQUEST: "ADD_SAMPLE_PHOTO_REQUEST",
  ADD_SAMPLE_PHOTO_SUCCESS: "ADD_SAMPLE_PHOTO_SUCCESS",
  ADD_SAMPLE_PHOTO_FAILURE: "ADD_SAMPLE_PHOTO_FAILURE",

  CLOSE_ALERT_TO_APPLICATION_CALL_ME: "CLOSE_ALERT_TO_APPLICATION_CALL_ME",
}
export const applicationConstants = {
  SET_MODAL_TYPE_APPLICATION: "SET_MODAL_TYPE_APPLICATION",
  VISIBLE_REGISTER_MODAL_APPLICATION: "VISIBLE_REGISTER_MODAL_APPLICATION",
  PASSWORDS_MATCH_APPLICATION_SUCCESS: "PASSWORDS_MATCH_APPLICATION_SUCCESS",

  CREATE_APPLICATION_REQUEST: "CREATE_APPLICATION_REQUEST",
  CREATE_APPLICATION_SUCCESS: "CREATE_APPLICATION_SUCCESS",
  CREATE_APPLICATION_FAILURE: "CREATE_APPLICATION_FAILURE",

  GET_APPLICATION_BY_USER_REQUEST: "GET_APPLICATION_BY_USER_REQUEST",
  GET_APPLICATION_BY_USER_SUCCESS: "GET_APPLICATION_BY_USER_SUCCESS",
  GET_APPLICATION_BY_USER_FAILURE: "GET_APPLICATION_BY_USER_FAILURE",

  ADD_SAMPLE_PHOTO_REQUEST: "ADD_SAMPLE_PHOTO_REQUEST",
  ADD_SAMPLE_PHOTO_SUCCESS: "ADD_SAMPLE_PHOTO_SUCCESS",
  ADD_SAMPLE_PHOTO_FAILURE: "ADD_SAMPLE_PHOTO_FAILURE",

  CLOSE_ALERT_TO_APPLICATION: "CLOSE_ALERT_TO_APPLICATION",
}



export const manufactureConstants = {
  GET_MANUFACTURE_REQUEST: "GET_MANUFACTURE_REQUEST",
  GET_MANUFACTURE_SUCCESS: "GET_MANUFACTURE_SUCCESS",
  GET_MANUFACTURE_FAILURE: "GET_MANUFACTURE_FAILURE",
}

export const mainImageConstants = {
  GET_MAIN_IMAGE_REQUEST: "GET_MAIN_IMAGE_REQUEST",
  GET_MAIN_IMAGE_SUCCESS: "GET_MAIN_IMAGE_SUCCESS",
  GET_MAIN_IMAGE_FAILURE: "GET_MAIN_IMAGE_FAILURE",
}

export const comeToUsConstants = {
  GET_COME_TO_US_REQUEST: "GET_COME_TO_US_REQUEST",
  GET_COME_TO_US_SUCCESS: "GET_COME_TO_US_SUCCESS",
  GET_COME_TO_US_FAILURE: "GET_COME_TO_US_FAILURE",
}

export const weWorkOnlineConstants = {
  GET_WE_WORK_ONLINE_REQUEST: "GET_WE_WORK_ONLINE_REQUEST",
  GET_WE_WORK_ONLINE_SUCCESS: "GET_WE_WORK_ONLINE_SUCCESS",
  GET_WE_WORK_ONLINE_FAILURE: "GET_WE_WORK_ONLINE_FAILURE",
}




export const promotionConstants = {
  GET_PROMOTION_REQUEST: "GET_PROMOTION_REQUEST",
  GET_PROMOTION_SUCCESS: "GET_PROMOTION_SUCCESS",
  GET_PROMOTION_FAILURE: "GET_PROMOTION_FAILURE",

  GET_PROMOTION_DETAILS_BY_ID_REQUEST: "GET_PROMOTION_DETAILS_BY_ID_REQUEST",
  GET_PROMOTION_DETAILS_BY_ID_SUCCESS: "GET_PROMOTION_DETAILS_BY_ID_SUCCESS",
  GET_PROMOTION_DETAILS_BY_ID_FAILURE: "GET_PROMOTION_DETAILS_BY_ID_FAILURE",

}

export const paymentConstants = {
  GET_PAYMENT_REQUEST: "GET_PAYMENT_REQUEST",
  GET_PAYMENT_SUCCESS: "GET_PAYMENT_SUCCESS",
  GET_PAYMENT_FAILURE: "GET_PAYMENT_FAILURE",

}

export const contactConstants = {
  GET_CONTACT_REQUEST: "GET_CONTACT_REQUEST",
  GET_CONTACT_SUCCESS: "GET_CONTACT_SUCCESS",
  GET_CONTACT_FAILURE: "GET_CONTACT_FAILURE",
}

export const graniteMaterialConstants = {
  GET_GRANITE_MATERIAL_REQUEST: "GET_GRANITE_MATERIAL_REQUEST",
  GET_GRANITE_MATERIAL_SUCCESS: "GET_GRANITE_MATERIAL_SUCCESS",
  GET_GRANITE_MATERIAL_FAILURE: "GET_GRANITE_MATERIAL_FAILURE",
}

export const paymentLIConstants = {
  GET_PAYMENT_LI_REQUEST: "GET_PAYMENT_LI_REQUEST",
  GET_PAYMENT_LI_SUCCESS: "GET_PAYMENT_LI_SUCCESS",
  GET_PAYMENT_LI_FAILURE: "GET_PAYMENT_LI_FAILURE",
}

export const costDeliveryConstants = {
  GET_COST_DELIVERY_REQUEST: "GET_COST_DELIVERY_REQUEST",
  GET_COST_DELIVERY_SUCCESS: "GET_COST_DELIVERY_SUCCESS",
  GET_COST_DELIVERY_FAILURE: "GET_COST_DELIVERY_FAILURE",
}

export const tombstoneCurbConstants = {
  GET_TOMBSTONE_CURB_REQUEST: "GET_TOMBSTONE_CURB_REQUEST",
  GET_TOMBSTONE_CURB_SUCCESS: "GET_TOMBSTONE_CURB_SUCCESS",
  GET_TOMBSTONE_CURB_FAILURE: "GET_TOMBSTONE_CURB_FAILURE",
}

export const galleryConstants = {
  GET_GALLERY_REQUEST: "GET_GALLERY_REQUEST",
  GET_GALLERY_SUCCESS: "GET_GALLERY_SUCCESS",
  GET_GALLERY_FAILURE: "GET_GALLERY_FAILURE",

  GET_GALLERY_BY_ID_REQUEST: "GET_GALLERY_BY_ID_REQUEST",
  GET_GALLERY_BY_ID_SUCCESS: "GET_GALLERY_BY_ID_SUCCESS",
  GET_GALLERY_BY_ID_FAILURE: "GET_GALLERY_BY_ID_FAILURE",

  UPDATE_GALLERY_VIEW_REQUEST: "UPDATE_GALLERY_VIEW_REQUEST",
  UPDATE_GALLERY_VIEW_SUCCESS: "UPDATE_GALLERY_VIEW_SUCCESS",
  UPDATE_GALLERY_VIEW_FAILURE: "UPDATE_GALLERY_VIEW_FAILURE",

  UPDATE_GALLERY_PICTURE_VIEW_REQUEST: "UPDATE_GALLERY_PICTURE_VIEW_REQUEST",
  UPDATE_GALLERY_PICTURE_VIEW_SUCCESS: "UPDATE_GALLERY_PICTURE_VIEW_SUCCESS",
  UPDATE_GALLERY_PICTURE_VIEW_FAILURE: "UPDATE_GALLERY_PICTURE_VIEW_FAILURE",
};
